(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'datatables',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings',['angularFileUpload', 'datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.settings', {
                url    : '/settings',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/settings.html',
                        controller : 'SettingsController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/settings/');

/*         // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title : '',
            group : true,
            weight: 1
        });
        msNavigationServiceProvider.saveItem('fuse.settings', {
            title    : 'SETTINGS',
            icon     : 'icon-account',
            state    : 'app.settings',
            translate: 'SETTINGS.SETTINGS_NAV',
            weight   : 1
        }); */

    }
})();
(function() {
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($http, $rootScope, $scope, $mdDialog, $state, $filter, FileUploader, SettingsService, Notification) {
        $scope.showLoading = false;
        var dataUploader = $scope.dataUploader = new FileUploader({
            url: $rootScope.serverBasePath + 'settings/uploadData',
            method: 'POST',
            queue: []
        });


        //console.log(dataUploader);
        //console.log($scope.dataUploader);
        $scope.data = '1';
        var vm = this;
        vm.contatti = [];
        vm.contatti.openinghours = [];

        //prendo l'ultima data di elaborazione inserita
        SettingsService.getDate().then(function(response) {
            if (response.success) {
                $scope.data_elaborazione = new Date(response.data);
            } else {
                Notification.error({
                    title: 'Errore',
                    message: 'Impossibile trovare un data di elaborazione',
                    positionY: 'top'
                });
            }
        });


        var initFileUploader = function() {
            return new FileUploader({
                url: $rootScope.serverBasePath + 'settings/uploadData',
                method: 'POST',
                queue: []
            });
        }


        var getInfoComune = function() {

            $scope.showLoading = false;

            SettingsService.getInfoComune(function(response) {

                if (response.comuni.anno_corrente) {
                    response.comuni.anno_corrente = parseInt(response.comuni.anno_corrente);
                } else {
                    response.comuni.anno_corrente = (new Date()).getFullYear();
                }

                vm.contatti = response.comuni;
                vm.contatti.id_comune = $rootScope.id_comune;
                vm.contatti.openinghours = getFormattedTime(response.orari);
                if (response.comuni.testi_informativi != null) {
                    vm.testiInformativi = JSON.parse(response.comuni.testi_informativi);
                } else {
                    vm.testiInformativi = [];
                }
            });
        }

        getInfoComune();

        $scope.popupMakeUsers = function() {
            var confirm = $mdDialog.confirm()
                .title('ATTENZIONE')
                .textContent('Tutti i contribuenti presenti nell\'anagrafica con email e cellulare valorizzati saranno automaticamente convertiti in utenti attivi e i dati per l\'accesso alla piattaforma verrano inviati. Vuoi procedere? Questa azione può richiedere fino a qualche minuto.')
                .ariaLabel('attenzione')
                .ok('SI')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                $scope.showLoading = true;
                SettingsService.makeUsers().then(function(response) {
                  $scope.showLoading = false;
                  //console.log(response);
                    if (response.success) {
                      if(response.data.usercount > 0){
                        Notification.success({
                            title: 'OPERAZIONE COMPLETATA',
                            message: 'Sono stati generati '+response.data.usercount+' nuovi utenti e sono state inviate '+response.data.mailcount+" email.",
                            positionY: 'top'
                        });
                      }else{
                        Notification.success({
                            title: 'OPERAZIONE COMPLETATA',
                            message: 'Tutti i contribuenti nell\'anagrafica sono iscritti alla piattaforma',
                            positionY: 'top'
                        });
                      }

                    } else {
                        Notification.error({
                            title: 'Attenzione',
                            message: 'Errore durante l\'operazione',
                            positionY: 'top'
                        });
                    }
                });

            }, function() {

            });
        }

        // salvo la data
        $scope.saveDate = function() {

            SettingsService.setDate(date).then(function(response) {
                if (response.success) {
                    Notification.success({
                        title: 'Salvato',
                        message: 'I cambiamenti sono stati caricati',
                        positionY: 'top'
                    });
                } else {
                    Notification.error({
                        title: 'Attenzione',
                        message: 'Errore durante il salvataggio',
                        positionY: 'top'
                    });
                }
            });
        }

        //salva le impostazioni selezionate in basso
        $scope.saveVisualSetting = function() {
            var date = moment($scope.data_elaborazione).format('YYYY-MM-DD');
            SettingsService.setDate(date, vm.contatti.anno_corrente, vm.contatti.note_immobile).then(function(response) {
                if (response.success) {
                    Notification.success({
                        message: 'I cambiamenti sono stati caricati',
                        positionY: 'top'
                    });
                } else {
                    Notification.error({
                        title: 'Attenzione',
                        message: 'Errore durante il salvataggio',
                        positionY: 'top'
                    });
                }
            });
        }




        //-------------------------------------------- UPLOAD EXCEL DATA --------------------------------------------------------------------------

        dataUploader.filters.push({
            name: 'syncFilter',
            fn: function(item /*{File|FileLikeObject}*/ , options) {
                //console.log('syncFilter');
                if ($scope.data == 1) {
                    return this.queue.length < (3 - vm.testiInformativi.length);
                } else {
                    return this.queue.length < 2;
                }
            }
        });

        // an async filter
        dataUploader.filters.push({
            name: 'asyncFilter',
            fn: function(item /*{File|FileLikeObject}*/ , options, deferred) {
                //console.log('asyncFilter');
                setTimeout(deferred.resolve, 1e3);
            }
        });

        dataUploader.filters.push({
            name: 'enforceMaxFileSize',
            fn: function(item) {
                return item.size <= 10485760; // 2 MB to bytes
            }
        });

        dataUploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/ , filter, options) {
            $scope.errorLimit = true;
            document.getElementById("uploadFile").value = "";
            //console.info('onWhenAddingFileFailed', item, filter, options);

            //Gestione degli errori nel Caricamento file

            if ($scope.data == 1 && (vm.testiInformativi.length == 3 || $scope.dataUploader.queue.length + vm.testiInformativi.length == 3)) {
                Notification.error({
                    title: 'Errore',
                    message: 'Numero massimo di testi informativi raggiunto, per procedere elimina almeno un elemento.',
                    positionY: 'top'
                });
            } else {
                Notification.error({
                    title: 'Errore',
                    message: 'File non valido',
                    positionY: 'top'
                });
            }

        };
        dataUploader.onAfterAddingFile = function(fileItem) {
            $scope.errorLimit = false;
            //console.info('onAfterAddingFile', fileItem);
        };
        dataUploader.onAfterAddingAll = function(addedFileItems) {
            //console.info('onAfterAddingAll', addedFileItems);
        };
        dataUploader.onBeforeUploadItem = function(item) {
            //console.info('onBeforeUploadItem', item);
        };
        dataUploader.onProgressItem = function(fileItem, progress) {
            //console.info('onProgressItem', fileItem, progress);
        };
        dataUploader.onProgressAll = function(progress) {
            //console.info('onProgressAll', progress);
        };
        dataUploader.onSuccessItem = function(fileItem, response, status, headers) {
            $scope.showLoading = false;
            //console.info('onSuccessItem', fileItem, response, status, headers);
            Notification.success({
                title: 'Caricamento completato ',
                message: 'Informazioni salvate con successo',
                positionY: 'top'
            });
        };
        dataUploader.onErrorItem = function(fileItem, response, status, headers) {
            //console.info('onErrorItem', fileItem, response, status, headers);
        };
        dataUploader.onCancelItem = function(fileItem, response, status, headers) {
            //console.info('onCancelItem', fileItem, response, status, headers);
        };
        dataUploader.onCompleteItem = function(fileItem, response, status, headers) {
            //console.info('onCompleteItem', fileItem, response, status, headers);
        };
        dataUploader.onCompleteAll = function() {
            document.getElementById("uploadFile").value = "";
            $scope.clearQueueUpload();
            getInfoComune();
        };

        $scope.deleteItem = function() {
            document.getElementById("uploadFile").value = "";
            dataUploader.queue.pop();
        }

        $scope.uploadData = function() {
            //console.info('dataUploader', dataUploader);
            $scope.dataUploader.queue[0].formData.push({
                'dataType': $scope.data,
                'id_comune': $rootScope.id_comune
            });
            if ($scope.data == 1) {
                $scope.dataUploader.queue[0].formData.push({
                    'id_comune': $rootScope.id_comune
                });
            }
            if ($scope.dataUploader.queue[1]) {
                $scope.dataUploader.queue[1].formData.push({
                    'dataType': $scope.data,
                    'id_comune': $rootScope.id_comune
                });
            }
            if ($scope.dataUploader.queue[2]) {
                $scope.dataUploader.queue[2].formData.push({
                    'dataType': $scope.data,
                    'id_comune': $rootScope.id_comune
                });
            }


            $scope.showLoading = true;


            $scope.dataUploader.uploadAll();

            if ($scope.data == 1) {
                for (var i = 0; i < $scope.dataUploader.queue.length; i++) {
                    /* var date = new Date();
                    var filename = $scope.dataUploader.queue[i].file.name.replace(' ','_') + "_"+ $filter('date')(date,'yyyyMMddhhmmss'); */
                    var filename = $scope.dataUploader.queue[i].file.name.replace(' ', '_');
                    vm.testiInformativi.push(filename);
                }

                var params = {
                    'testi': angular.toJson(vm.testiInformativi),
                    'id_comune': $rootScope.id_comune
                }

                SettingsService.updateTestiInformativi(function(response) {
                    getInfoComune();
                }, params);
            }
        }


        //controlla se la dimendione del file è più piccola di un MB
        $scope.checkDimension = function() {
            if ($scope.dataUploader.queue.length > 0) {
                var dimension = $scope.dataUploader.queue[0].file.size / 1024 / 1024;
                dimension = Number((dimension).toFixed(2));

                if (dimension == 0) {
                    return false;
                } else {
                    return true;
                }

            }
        }


        //pulisce la coda del fle uploader
        $scope.clearQueueUpload = function() {
            for (var i = 0; i < $scope.dataUploader.queue.length; i++) {
                $scope.dataUploader.queue[i].remove();
            }
            for (var i = 0; i < $scope.dataUploader.queue.length; i++) {
                $scope.dataUploader.queue[i].remove();
            }
            document.getElementById("uploadFile").value = "";
        }

        //-------------------------------------------- END UPLOAD EXCEL DATA --------------------------------------------------------------------------


        $scope.saveInfoComune = function() {
            SettingsService.saveInfoComune(function(response) {
                Notification.success({
                    title: 'Contatti ',
                    message: 'Informazioni salvate con successo',
                    positionY: 'top'
                });
            }, vm.contatti);
        }

        $scope.addOpeninghour = function() {

            SettingsService.addOpeninghour(function(response) {
                getInfoComune();
            }, $scope.opnhour);
        }



        var getFormattedTime = function(hours) {
            //get working hour grouped by day of week
            var shophours = new Array();
            for (var i = 0; i < hours.length; i++) {
                var day = hours[i].orari_apertura.day_week != 0 ? hours[i].orari_apertura.day_week - 1 : 6; //se è domenica lo metto sul 6 cosi è ordinato giusto
                if (shophours[day] == null) {
                    var data = {
                        day_week: hours[i].orari_apertura.day_week,
                        day_hours: new Array()
                    }
                    shophours[day] = data;
                }

                shophours[day].day_hours.push(hours[i].orari_apertura);
            }
            return shophours;
        }




        $scope.deleteOpnhour = function(day_week) {
            var confirm = $mdDialog.confirm()
                .title('Elimina orario di apertura')
                .textContent("Sei sicuro di voler eliminare l'orario di " + $scope.getLongDay(day_week) + "?")
                .ariaLabel('')
                .clickOutsideToClose(false)
                .parent(angular.element(document.body))
                .ok('Elimina')
                .cancel('Annulla');

            $mdDialog.show(confirm).then(function() {
                var params = {
                    day_week: day_week,
                    id_comune: $rootScope.id_comune
                }

                SettingsService.deleteOpnhour(function(response) {
                    getInfoComune();
                }, params);
            }, function() {});
        }


        $scope.getDay = function(day) {
            switch (day) {
                case '1':
                    return 'Lun';
                    break;
                case '2':
                    return 'Mar';
                    break;
                case '3':
                    return 'Mer';
                    break;
                case '4':
                    return 'Gio';
                    break;
                case '5':
                    return 'Ven';
                    break;
                case '6':
                    return 'Sab';
                    break;
                case '0':
                    return 'Dom';
                    break;
                default:
                    return '';
                    break;
            }
        }

        $scope.getLongDay = function(day) {
            switch (day) {
                case '1':
                    return 'Lunedì';
                    break;
                case '2':
                    return 'Martedì';
                    break;
                case '3':
                    return 'Mercoledì';
                    break;
                case '4':
                    return 'Giovedì';
                    break;
                case '5':
                    return 'Venerdì';
                    break;
                case '6':
                    return 'Sabato';
                    break;
                case '0':
                    return 'Domenica';
                    break;
                default:
                    return '';
                    break;
            }
        }

        $scope.disopnhour = function() {
            return $scope.opnhour == null || $scope.opnhour.day_week == null || $scope.opnhour.start_hour == null || $scope.opnhour.end_hour == null;
        }

        $scope.getHour = function(hour) {
            return hour.substring(0, 5);
        }

        $scope.deleteFile = function(index) {

            vm.testiInformativi.splice(index, 1);

            var params = {
                'testi': angular.toJson(vm.testiInformativi),
                'id_comune': $rootScope.id_comune
            }

            SettingsService.updateTestiInformativi(function(response) {
                getInfoComune();
            }, params);

        }
    }
})();

(function() {
    'use strict';

    angular
      .module('app.settings')
      .factory('SettingsService', SettingsService);

    /** @ngInject */
    function SettingsService($http, $rootScope, $location, $q) {
      var service = {};

      service.getInfoComune = function(callback) {
        var param = {'id_comune': $rootScope.id_comune};
        var promise = $http({
          method: 'POST',
          data: $.param(param),
          url     : $rootScope.serverBasePath + 'settings/getInfoComune',
          headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(function successCallback(response) {
          callback(response.data.data);
        });
      };

      service.saveInfoComune = function(callback, contatti) {
        //console.info('contatti', contatti);

        $http({
            method  : 'POST',
            data: $.param(contatti),
            url     : $rootScope.serverBasePath + 'settings/saveInfoComune',
            headers : { 'Content-Type': 'application/x-www-form-urlencoded' }  // set the headers so angular passing info as form data (not request payload)
        })
        .then(function successCallback(response) {
            //console.info('response', response);
            callback(response.data.data);
        });

      };

      service.addOpeninghour = function(callback, opnhour) {
        var payload = $rootScope.convertToFormData(opnhour);
        payload.append("start_hour", dateFormat(opnhour.start_hour));
        payload.append("end_hour", dateFormat(opnhour.end_hour));
        payload.append('id_comune', $rootScope.id_comune);

        var promise = $http({
          method: 'POST',
          url: $rootScope.serverBasePath + 'settings/addOpeninghour',
          data: payload,
          headers: {
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        }).then(function successCallback(response) {
          //  console.log(response.data);
          callback(response.data);
        });
      };



      service.deleteOpnhour = function(callback, params) {
        var payload = $rootScope.convertToFormData(params);
        var promise = $http({
          method: 'POST',
          url: $rootScope.serverBasePath + 'settings/deleteOpeninghour',
          data: payload,
          headers: {
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        }).then(function successCallback(response) {
          //  console.log(response.data);
          callback(response.data);
        });
      };

      service.updateTestiInformativi = function(callback, params) {
        var payload = $rootScope.convertToFormData(params);
        var promise = $http({
          method: 'POST',
          url: $rootScope.serverBasePath + 'settings/updateTestiInformativi',
          data: payload,
          headers: {
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        }).then(function successCallback(response) {
          //  console.log(response.data);
          callback(response.data);
        });
      };

      //richeido la data di elaborazione
      service.getDate = function() {
        var data = {'id_comune': $rootScope.id_comune};
          var dfd = $q.defer();
          var promise = $http({
              method: 'POST',
              url: $rootScope.serverBasePath + 'settings/getDate',
              data: $.param(data),
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(function successCallback(response) {
                  dfd.resolve(response.data);
          });

          $rootScope.loadingTracker.addPromise(promise);
          return dfd.promise;
      };

      //salvo la data di elaborazione
      service.setDate = function(date,anno_corrente,note_immobile) {
        var data = {'id_comune': $rootScope.id_comune, 'data_elaborazione': date,'anno_corrente': anno_corrente,'note_immobile': note_immobile, };
          var dfd = $q.defer();
          var promise = $http({
              method: 'POST',
              url: $rootScope.serverBasePath + 'settings/setDate',
              data: $.param(data),
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(function successCallback(response) {
                  dfd.resolve(response.data);
          });

          $rootScope.loadingTracker.addPromise(promise);
          return dfd.promise;
      };

      //genero gli user
      service.makeUsers = function() {
        var data = {'id_comune': $rootScope.id_comune};
          var dfd = $q.defer();
          var promise = $http({
              method: 'POST',
              url: $rootScope.serverBasePath + 'settings/makeAccounts',
              data: $.param(data),
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(function successCallback(response) {
                  dfd.resolve(response.data);
          });
          return dfd.promise;
      };

      return service;
    }

    var dateFormat = function(date) {
      var date = new Date(date);
      var hour = date.getHours();
      var minutes = date.getMinutes();
      return hour + ":" + minutes;
    }
  })();

(function ()
{
    'use strict';

    angular
        .module('app.registrationRequest', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.registrationRequest', {
                url    : '/registrationRequest',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/registrationRequest/registrationRequest.html',
                        controller : 'RegistrationRequestController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/registrationRequest/');

    }
})();
(function() {
    'use strict';
  
    angular
      .module('app.registrationRequest')
      .factory('RegistrationRequestService', RegistrationRequestService);
  
    /** @ngInject */
    function RegistrationRequestService($http, $rootScope, $location) {
      var service = {};
      
      service.acceptUser = function(callback, param) {
        //console.info('contatti', contatti);

        $http({
            method: 'POST',
            url: $rootScope.serverBasePath + 'users/acceptUser',
            data: $.param(param),
            // set the headers so angular passing info as form data (not request payload)
            headers : { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function(response) { 
            callback(response.data);
        });        
      };

      service.deleteAllRequests = function(callback, param) {
        //console.info('contatti', contatti);

        $http({
            method: 'POST',
            url: $rootScope.serverBasePath + 'users/deleteAllRequests',
            data: $.param(param),
            // set the headers so angular passing info as form data (not request payload)
            headers : { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function(response) { 
            callback(response.data);
        });        
      };

      return service;
    }
  
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.registrationRequest')
        .controller('RegistrationRequestController', RegistrationRequestController);

    /** @ngInject */
    function RegistrationRequestController($http,$rootScope,$scope,$interval,DTDefaultOptions,DTOptionsBuilder,DTColumnBuilder,$compile,$mdDialog,RegistrationRequestService, Notification)
    {
        var vm = this;
        $scope.param = {'id_comune' : $rootScope.id_comune};

        // Display 50 items per page by default
         DTDefaultOptions.setDisplayLength(50);

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {

                // Either you specify the AjaxDataProp here
                data: $scope.param,
                url: $rootScope.serverBasePath + 'users/getRegistrationRequest',
                type: 'POST'
            })
            .withOption('order', [ 1, 'asc' ])
            .withOption('createdRow', createdRow)
            .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withPaginationType('simple');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('anagrafica.cognome').withTitle('COGNOME'),
            DTColumnBuilder.newColumn('anagrafica.nome').withTitle('NOME'),
            DTColumnBuilder.newColumn('users.username').withTitle('CODICE FISCALE'),
            DTColumnBuilder.newColumn(null).withTitle('DOCUMENTO').notSortable().renderWith(documentButton),
            DTColumnBuilder.newColumn(null).withTitle('AZIONE').renderWith(actionButton)
        ];
        vm.reloadData = reloadData;
        vm.dtInstance = {};


        // Methods

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            //else ng-click on button DONT WORKS
            $compile(angular.element(row).contents())($scope);
        }


        function reloadData() {
            var resetPaging = false;
            vm.dtInstance.reloadData(null, resetPaging);
        }

        function isImage(name) {
            return (
              name.includes(".jfif") ||
              name.includes(".jfif-tbnl") ||
              name.includes(".jpe") ||
              name.includes(".jpeg") ||
              name.includes(".jpg") ||
              name.includes(".gif") ||
              name.includes(".png") ||
              name.includes(".x-png")
            )
          }

        $scope.showAttachment = function(media) {

            var imgPath = null;
            if (document.location.hostname != "localhost") {
              imgPath = $rootScope.serverBasePath + 'webroot/upload/documenti/' + $rootScope.id_comune + '/' + media;
            } else {
              imgPath = 'http://localhost/portale-imu-server/webroot/upload/documenti/' + $rootScope.id_comune + '/' + media;
            }
      
            var template = null;
      
            if (isImage(media)) {
              template = '<img style="height:900px;" src="' + imgPath + '" />';
            } else if (media.includes(".pdf")) {
              template = ' <iframe src="' + imgPath + '" width="600px" height="900px">';
            } else {
              Notification.warning({
                title: 'ATTENZIONE',
                message: 'Formato non riconosciuto',
                positionY: 'top'
              });
            }
      
            if(template != null){
              $mdDialog.show({
                template: template,
                parent: angular.element(document.body),
                clickOutsideToClose: true
              });
            }

        };

        $scope.acceptUser = function(codFiscale, codAna){

            $scope.param = {'cod_ana' : codAna, 'id_comune': $rootScope.id_comune};

            RegistrationRequestService.acceptUser(function(response) {
                if(response.success){
                    Notification.success({
                        title: 'OPERAZIONE EFFETTUATA',
                        message: 'Utente abilitato con successo',
                        positionY: 'top'
                    });
                    reloadData();
                } else{
                    Notification.warning({
                        title: 'ATTENZIONE',
                        message: 'Operazione non eseguita',
                        positionY: 'top'
                    });
                }

              }, $scope.param);
        }

        
        $scope.deleteAllRequests = function(){

            if(!confirm('Sei sicuro di voler eliminare tutte le richieste?')){
                return;
            }

            $scope.param = {'id_comune': $rootScope.id_comune};
            RegistrationRequestService.deleteAllRequests(function(response) {
                if(response.success){
                    Notification.success({
                        title: 'OPERAZIONE EFFETTUATA',
                        message: 'Richieste eliminate',
                        positionY: 'top'
                    });
                    reloadData();
                } else{
                    Notification.warning({
                        title: 'ATTENZIONE',
                        message: 'Operazione non eseguita',
                        positionY: 'top'
                    });
                }

              }, $scope.param);

        }

        function documentButton(data) {

            var showRetroButton = false;
            if( data.users.doc_retro !="" ){
                showRetroButton = true;
            }

            if(data.users.doc!=""){
              return '<button class="btn btn-warning" ng-click="showAttachment(\''+data.users.doc+'\')">' +
              '<md-icon md-font-icon="icon-file-outline" class="icon ng-scope ng-isolate-scope md-font icon-file-outline material-icons md-default-theme" style="color:blue; aria-hidden="true"></md-icon>' +
                  '</button>' +
                  '<button class="btn btn-warning" ng-show="'+showRetroButton+'" ng-click="showAttachment(\''+data.users.doc_retro+'\')">' +
                  '<md-icon md-font-icon="icon-file-outline" class="icon ng-scope ng-isolate-scope md-font icon-file-outline material-icons md-default-theme" style="color:blue; aria-hidden="true"></md-icon>' +
                      '</button>';
            }else{
              return "";
            }

        }

        function actionButton(data) {

                return '<button class="btn btn-warning" ng-click="acceptUser(\''+data.users.username+'\', '+data.users.cod_ana+')">' +
                    '<md-icon md-font-icon="icon-account-check" class="icon ng-scope ng-isolate-scope md-font icon-account-check material-icons md-default-theme" style="color:green;" aria-hidden="true"></md-icon>' +
                    '</button>';

        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.infoComune',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.infoComune', {
                url    : '/infoComune',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/infoComune/infoComune.html',
                        controller : 'InfoComuneController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/infoComune/');


    }
})();
(function() {
    'use strict';

    angular
      .module('app.infoComune')
      .factory('InfoComuneSrevice', InfoComuneSrevice);

    /** @ngInject */
    function InfoComuneSrevice($http, $rootScope, $location) {
      var service = {};

      service.getInfoComune = function(callback) {
        var param = {'id_comune': $rootScope.id_comune};
        var promise = $http({
          method: 'POST',
          data: $.param(param),
          url     : $rootScope.serverBasePath + 'settings/getInfoComune',
          headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(function successCallback(response) {
          callback(response.data.data);
        });
      };

      service.getInfoUtente = function(callback){
        var param = {'cod_fiscale' : $rootScope.globals.currentUser.username, 'id_comune': $rootScope.id_comune};
        var promise = $http({
          method: 'POST',
          data: $.param(param),
          url     : $rootScope.serverBasePath + 'settings/getInfoUtente',
          headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(function successCallback(response) {
          callback(response.data.data);
        });
      }


      return service;
    }
  })();

(function() {
    'use strict';

    angular
        .module('app.infoComune')
        .controller('InfoComuneController', InfoComuneController);

    /** @ngInject */
    function InfoComuneController($http, $rootScope, $scope, $state, InfoComuneSrevice) {
        var vm = this;

        var getInfoUtente = function() {
            InfoComuneSrevice.getInfoUtente(function(response) {

                $scope.email = angular.isUndefined($rootScope.globals.currentUser.email) ? "" : $rootScope.globals.currentUser.email;
                $scope.cellulare = angular.isUndefined($rootScope.globals.currentUser.cellulare) ? "" : " - " + $rootScope.globals.currentUser.cellulare;
                $scope.interno="";
                //console.log(response.anagrafica);
                if(response.anagrafica.interno != "NULL" && response.anagrafica.interno != "" && response.anagrafica.interno){
                  $scope.interno = " int. " + response.anagrafica.interno+" ";
                }else{
                  $scope.interno = "";
                }

                if (response.anagrafica.sesso == "F") {
                    $scope.titolo = "BENVENUTA " + response.anagrafica.cognome + " " + response.anagrafica.nome + " - " + response.anagrafica.indirizzo.toLowerCase() + " " + response.anagrafica.civico +"-"+ response.anagrafica.barrato +$scope.interno+ ", " + $rootScope.globals.currentUser.comune.toLowerCase();
                    $scope.titolo = $scope.titolo.toUpperCase();
                } else {
                    $scope.titolo = "BENVENUTO " + response.anagrafica.cognome + " " + response.anagrafica.nome + " - " + response.anagrafica.indirizzo.toLowerCase() + " " + response.anagrafica.civico +"-"+ response.anagrafica.barrato +$scope.interno+ ", " + $rootScope.globals.currentUser.comune.toLowerCase();
                    $scope.titolo = $scope.titolo.toUpperCase();
                }
            });

        }

        vm.contatti = [];
        vm.contatti.openinghours = [];

        var getInfoComune = function() {
            InfoComuneSrevice.getInfoComune(function(response) {
                vm.contatti = response.comuni;
                vm.contatti.openinghours = getFormattedTime(response.orari);
                vm.documents = [];

                var documents = JSON.parse(response.comuni.testi_informativi);
                if(documents != null){
                  for (var i = 0; i < documents.length; i++) {
                      if (document.location.hostname != "localhost")
                          vm.documents.push({
                              label: documents[i],
                              path: $rootScope.serverBasePath + 'webroot/upload/testi/' + $rootScope.id_comune + '/' + documents[i]
                          });
                      else vm.documents.push({
                          label: documents[i],
                          path: 'http://localhost/portale-imu-server/webroot/upload/testi/' + $rootScope.id_comune + '/' + documents[i]
                      });
                  }
                }

                getInfoUtente();
            });

        }

        getInfoComune();


        var getFormattedTime = function(hours) {
            //get working hour grouped by day of week
            var shophours = new Array();
            for (var i = 0; i < hours.length; i++) {
                var day = hours[i].orari_apertura.day_week != 0 ? hours[i].orari_apertura.day_week - 1 : 6; //se è domenica lo metto sul 6 cosi è ordinato giusto
                if (shophours[day] == null) {
                    var data = {
                        day_week: hours[i].orari_apertura.day_week,
                        day_hours: new Array()
                    }
                    shophours[day] = data;
                }

                shophours[day].day_hours.push(hours[i].orari_apertura);
            }
            return shophours;
        }

        $scope.getLongDay = function(day) {
            switch (day) {
                case '1':
                    return 'Lunedì';
                    break;
                case '2':
                    return 'Martedì';
                    break;
                case '3':
                    return 'Mercoledì';
                    break;
                case '4':
                    return 'Giovedì';
                    break;
                case '5':
                    return 'Venerdì';
                    break;
                case '6':
                    return 'Sabato';
                    break;
                case '0':
                    return 'Domenica';
                    break;
                default:
                    return '';
                    break;
            }
        }


        $scope.getHour = function(hour) {
            return hour.substring(0, 5);
        }

        /*         $scope.param = {'comune' : $rootScope.globals.currentUser.comune};

                $http({
                        method  : 'POST',
                        data: $.param($scope.param),
                        url     : $rootScope.serverBasePath + 'settings/getInfoComune',
                        headers : { 'Content-Type': 'application/x-www-form-urlencoded' }  // set the headers so angular passing info as form data (not request payload)
                    })
                    .then(function(response) {
                        vm.contatti =
                        console.info('response', response);
                    }); */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.datiStorici', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.datiStorici', {
                url    : '/datiStorici',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/datiStorici/datiStorici.html',
                        controller : 'DatiStoriciController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/datiStorici/');

    }
})();

(function() {
  'use strict';

  angular
    .module('app.datiStorici')
    .factory('DatiStoriciService', DatiStoriciService);

  /** @ngInject */
  function DatiStoriciService($http, $rootScope, $location, $q) {
    var service = {};


    //Prendo la lista degli anni disponibili
    service.getYearsList = function(callback, param) {

      $http({
          method: 'POST',
          data: $.param(param),
          url: $rootScope.serverBasePath + 'anagrafiche/getYearsList',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(function(response) {
          callback(response.data);

        });
    }

    service.getDatiStorici = function(callback, param) {

      $http({
          method: 'POST',
          data: $.param(param),
          url: $rootScope.serverBasePath + 'anagrafiche/getDatiStorici',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          } // set the headers so angular passing info as form data (not request payload)
        })
        .then(function(response) {
          callback(response.data);

        });
    }


    //prendo id dati relativi ai pagamenti dell'utente
    service.getUserTotals = function(data) {

      var dfd = $q.defer();
      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'anagrafiche/getUserTotalsHistory',
        data: $.param(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        dfd.resolve(response.data);
      });

      $rootScope.loadingTracker.addPromise(promise);
      return dfd.promise;

    };

    //prendo id dati relativi ai pagamenti dell'utente
    service.showNotes = function() {

      var data = {
        'id_comune': $rootScope.id_comune
      };
      var dfd = $q.defer();
      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'users/showNotes',
        data: $.param(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        dfd.resolve(response.data);
      });

      $rootScope.loadingTracker.addPromise(promise);
      return dfd.promise;

    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.datiStorici')
    .controller('DatiStoriciController', DatiStoriciController);

  /** @ngInject */
  function DatiStoriciController($http, $rootScope, $scope, $interval, SettingsService, DTDefaultOptions, DTOptionsBuilder, DTColumnBuilder, $compile, $mdDialog, DatiStoriciService, $filter, Notification) {
    var vm = this;

    //inizializzo per non mostrare nel caso mancassero i dati
    $scope.userTotals = [null, null];
    $scope.visible = false;




    DatiStoriciService.getYearsList(function(response) {
      if (response.success) {
        $scope.years = response.data;

        DatiStoriciService.showNotes().then(function(response) {
          if (response.success) {
            if (response.data) {
              $scope.booleanNotes = true;
            } else {
              $scope.booleanNotes = false;
            }
          } else {
            Notification.warning({
              title: 'ATTENZIONE!',
              message: "Errore nel recuperare le note",
              positionY: 'top'
            });
          }
        });

      } else {
        Notification.warning({
          title: 'ATTENZIONE',
          message: "Nessun anno disponibile",
          positionY: 'top'
        });
      }
    }, {
      'codAna': $rootScope.globals.currentUser.codAna,
      'codFisc': $rootScope.globals.currentUser.username,
      'id_comune': $rootScope.id_comune
    });


    $scope.getDatiStorici = function() {
      $scope.userTotals = [null, null];
      $scope.immobiliImu = [];
      $scope.immobiliTasi = [];
      $scope.totali = [];
      //console.log("anno", $scope.selectedYear);
      $scope.param = {
        'codAna': $rootScope.globals.currentUser.codAna,
        'codFisc': $rootScope.globals.currentUser.username,
        'id_comune': $rootScope.id_comune,
        'anno': $scope.selectedYear
      };
      DatiStoriciService.getDatiStorici(function(response) {
        $scope.immobiliImu = response.immobiliImu;
        $scope.immobiliTasi = response.immobiliTasi;
        $scope.totali = response.totali;
       //console.log($scope.immobiliImu);
      }, $scope.param);

      //carico i dati del pagamento utente
      DatiStoriciService.getUserTotals({
        'cf_user': $rootScope.globals.currentUser.username,
        'id_comune': $rootScope.id_comune,
        'anno': $scope.selectedYear
      }).then(function(response) {
        if (response.success) {
          $scope.visible = true;
          //controllo se ho sia i dati dei pagamenti di TASI che di IMU
          if (response.data.length > 1) {
            $scope.userTotals[0] = response.data[0];
            $scope.userTotals[1] = response.data[1];
          } else {

            //se non li ho entrambi controllo quali ho e avviso che mancano gli altri
            if (response.data[0].pagamenti_utente.tributo == "0") {
              $scope.userTotals[0] = response.data[0];
              Notification.warning({
                title: 'ATTENZIONE',
                message: "I dati relativi al pagamento di 'TASI' non sono stati trovati",
                positionY: 'top'
              });
            } else {
              $scope.userTotals[1] = response.data[0];
              Notification.warning({
                title: 'ATTENZIONE',
                message: "I dati relativi al pagamento di 'IMU' non sono stati trovati",
                positionY: 'top'
              });
            }
          }
        } else {
          Notification.warning({
            title: 'ATTENZIONE',
            message: "Errore nel ricevere i pagamenti utente",
            positionY: 'top'
          });
        }

      })
    }



    //controllo quale tab mostrare
    $scope.checkIMUTASI = function(index) {
      if ($scope.userTotals[index]) {
        return true;
      } else {
        return false;
      }
    }

    //gestione del checkbox per mostrare le note
    $scope.checkBoolean = function() {
      if (angular.isUndefined($scope.booleanNotes) || $scope.booleanNotes == null) {
        return false;
      } else {
        if ($scope.booleanNotes == true) {
          return true;
        } else {
          return false;
        }
      }

    }

    $scope.customStyleWindows = function() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      var trident = ua.indexOf('Trident/');
      var edge = ua.indexOf('Edge/');

      if (msie > 0 || trident > 0 || edge > 0) {
        //console.log("Microsoft");
        var myStyle = {
          "min-width": "30%"
        };
        return myStyle;
      }
    }

    //restituisco i dati in base al campo richiesto
    $scope.getDataFromTotals = function(index) {
      if ($scope.userTotals[0] && !$scope.userTotals[1]) {
        switch (index) {
          case 0:
            return $scope.userTotals[0].pagamenti_utente.totale;
            break;
          case 1:
            return $scope.userTotals[0].pagamenti_utente.versato;
            break;
          case 2:
            return $scope.userTotals[0].pagamenti_utente.differenza;
            break;
          default:
            break;

        }
      } else if (!$scope.userTotals[0] && $scope.userTotals[1]) {
        switch (index) {
          case 3:
            return $scope.userTotals[1].pagamenti_utente.totale;
            break;
          case 4:
            return $scope.userTotals[1].pagamenti_utente.versato;
            break;
          case 5:
            return $scope.userTotals[1].pagamenti_utente.differenza;
            break;

          default:
            break;
        }
      } else {
        switch (index) {
          case 0:
            return $scope.userTotals[0].pagamenti_utente.totale;
            break;
          case 1:
            return $scope.userTotals[0].pagamenti_utente.versato;
            break;
          case 2:
            return $scope.userTotals[0].pagamenti_utente.differenza;
            break;
          case 3:
            return $scope.userTotals[1].pagamenti_utente.totale;
            break;
          case 4:
            return $scope.userTotals[1].pagamenti_utente.versato;
            break;
          case 5:
            return $scope.userTotals[1].pagamenti_utente.differenza;
            break;

          default:
            break;

        }
      }
    }

    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: true,
      bFilter: false,
      bInfo: false,
      bSort: false,
      responsive: true
    };



    $scope.printF24 = function() {
      $scope.param = {
        'codAna': $rootScope.globals.currentUser.codAna,
        'codFisc': $rootScope.globals.currentUser.username,
        'id_comune': $rootScope.id_comune
      };

      DatiStoriciService.printF24(function(response) {
        if (document.location.hostname != "localhost")
          var fileURL = $rootScope.serverBasePath + 'webroot/' + response;
        else var fileURL = 'http://localhost/portale-imu-server/webroot/' + response;
        console.info('fileURL', fileURL);
        //window.open(fileURL);

        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = response;
        document.body.appendChild(a);
        a.click();

      }, $scope.param);
    }

    $scope.printImu = function() {

      var doc = new jsPDF({
        orientation: 'landscape'
      });

      doc.setFontSize(10);
      //doc.text('ELENCO IMMOBILI IMU ' + $rootScope.globals.currentUser.nome, 10, 15);
      if ($scope.checkBoolean()) {
        var columns = ["Dati Catastali", "Indirizzo", "% Quota", "Mesi", "Rendita catastale", "Valore imponibile", "Detr ab.pr", "Ab.Rd.Es.", "Comune Aliq-Imposta", "Stato Aliq-Imposta", "Note"];
      } else {
        var columns = ["Dati Catastali", "Indirizzo", "% Quota", "Mesi", "Rendita catastale", "Valore imponibile", "Detr ab.pr", "Ab.Rd.Es.", "Comune Aliq-Imposta", "Stato Aliq-Imposta"];
      }
      var rows = [];
      for (var i = 0; i < $scope.immobiliImu.length; i++) {
        if ($scope.checkBoolean()) {
          rows.push([
            $scope.immobiliImu[i].immobili.foglio + "/" + $scope.immobiliImu[i].immobili.mappale + "/" + $scope.immobiliImu[i].immobili.subalterno + "-" + $scope.immobiliImu[i].immobili.cat,
            $scope.immobiliImu[i].immobili.indirizzo + " " + $scope.immobiliImu[i].immobili.civico,
            $scope.immobiliImu[i].immobili.perc,
            $scope.immobiliImu[i].immobili.mesi,
            $scope.immobiliImu[i].immobili.rendita,
            $scope.immobiliImu[i].immobili.valore,
            $scope.immobiliImu[i].immobili.detrazione,
            $scope.immobiliImu[i].immobili.abpr + "-" + $scope.immobiliImu[i].immobili.rid + "-" + $scope.immobiliImu[i].immobili.ese,
            $scope.immobiliImu[i].immobili.al_comune + "-" + $scope.immobiliImu[i].immobili.imp_comune,
            $scope.immobiliImu[i].immobili.al_stato + "-" + $scope.immobiliImu[i].immobili.imu_stato,
            $scope.immobiliImu[i].immobili.note_immobile
          ]);
        } else {
          rows.push([
            $scope.immobiliImu[i].immobili.foglio + "/" + $scope.immobiliImu[i].immobili.mappale + "/" + $scope.immobiliImu[i].immobili.subalterno + "-" + $scope.immobiliImu[i].immobili.cat,
            $scope.immobiliImu[i].immobili.indirizzo + " " + $scope.immobiliImu[i].immobili.civico,
            $scope.immobiliImu[i].immobili.perc,
            $scope.immobiliImu[i].immobili.mesi,
            $scope.immobiliImu[i].immobili.rendita,
            $scope.immobiliImu[i].immobili.valore,
            $scope.immobiliImu[i].immobili.detrazione,
            $scope.immobiliImu[i].immobili.abpr + "-" + $scope.immobiliImu[i].immobili.rid + "-" + $scope.immobiliImu[i].immobili.ese,
            $scope.immobiliImu[i].immobili.al_comune + "-" + $scope.immobiliImu[i].immobili.imp_comune,
            $scope.immobiliImu[i].immobili.al_stato + "-" + $scope.immobiliImu[i].immobili.imu_stato
          ]);
        }

      }

      doc.autoTable(columns, rows, {
        theme: 'grid',
        styles: {
          fontSize: 8
        },
        headerStyles: {
          fillColor: [169, 169, 169]
        },
        margin: {
          top: 25
        },
        addPageContent: function(data) {
          doc.text('ELENCO IMMOBILI IMU ' + $rootScope.globals.currentUser.nome, 10, 15);
        }
      });
      doc.save('ImmobiliImu.pdf');
    }

    $scope.printTasi = function() {

      var doc = new jsPDF({
        orientation: 'landscape'
      });

      doc.setFontSize(10);
      var columns = ["Dati Catastali", "Indirizzo", "% Quota", "Mesi", "Rendita catastale", "Valore imponibile", "Detr ab.pr", "Ab.Rd.Es.", "Comune Aliq-Imposta", "Stato Aliq-Imposta", "Note"];
      var rows = [];
      for (var i = 0; i < $scope.immobiliTasi.length; i++) {
        rows.push([
          $scope.immobiliTasi[i].immobili.foglio + "/" + $scope.immobiliTasi[i].immobili.mappale + "/" + $scope.immobiliTasi[i].immobili.subalterno + "-" + $scope.immobiliTasi[i].immobili.cat,
          $scope.immobiliTasi[i].immobili.indirizzo + " " + $scope.immobiliTasi[i].immobili.civico,
          $scope.immobiliTasi[i].immobili.perc,
          $scope.immobiliTasi[i].immobili.mesi,
          $scope.immobiliTasi[i].immobili.rendita,
          $scope.immobiliTasi[i].immobili.valore,
          $scope.immobiliTasi[i].immobili.detrazione,
          $scope.immobiliTasi[i].immobili.abpr + "-" + $scope.immobiliTasi[i].immobili.rid + "-" + $scope.immobiliTasi[i].immobili.ese,
          $scope.immobiliTasi[i].immobili.al_comune + "-" + $scope.immobiliTasi[i].immobili.imp_comune,
          $scope.immobiliTasi[i].immobili.al_stato + "-" + $scope.immobiliTasi[i].immobili.imu_stato,
          $scope.immobiliTasi[i].immobili.note_immobile
        ]);
      }

      doc.autoTable(columns, rows, {
        theme: 'grid',
        styles: {
          fontSize: 8
        },
        headerStyles: {
          fillColor: [169, 169, 169]
        },
        margin: {
          top: 25
        },
        addPageContent: function(data) {
          doc.text('ELENCO IMMOBILI TASI ' + $rootScope.globals.currentUser.nome, 10, 15);
        }
      });
      doc.save('immobiliTasi.pdf');
    }


    //mostra la legenda premendo sul pulsante i (F24)
    $scope.showInfoF24 = function() {
      $mdDialog.show({
        //targetEvent: $event,
        fullscreen: false,
        template: '<div style="padding:25px;position: relative;"> <button class="btn btn-warning" ng-click="hideInfo()" style="position: absolute;right:25px;top:25px;"><md-icon md-font-icon="icon-close-circle-outline" class="icon ng-scope ng-isolate-scope md-font icon-close-circle-outline material-icons md-default-theme" aria-hidden="true"></md-icon></button><h2 style="text-align:center;font-weight: bold;">LEGENDA</h2><br><table class="simple" ms-responsive-table ><tbody>' +
          '<tr><td><span style="font-weight: bold;">Acc saldo</span></td><td><span>Acconto (A) o Saldo (S)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">EL</span></td><td><span>Colonna modello F24 vale Enti Locali (EL)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Ente</span></td><td><span>Codice catasto del Comune</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Codtr</span></td><td><span>Codice tributo</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">NR</span></td><td><span>Numero immobili</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Detrazione</span></td><td><span>Detrazione abitazione principale</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Importo</span></td><td><span>Importo da versare in acconto a saldo</span></td></tr>' +
          '</tbody></table></div>',
        controller: DialogController
      });
    }

    //mostra la legenda premendo sul pulsante i
    $scope.showInfo = function() {
      $mdDialog.show({
        //targetEvent: $event,
        fullscreen: false,
        template: '<div style="padding:25px;position: relative;"> <button class="btn btn-warning" ng-click="hideInfo()" style="position: absolute;right:25px;top:25px;"><md-icon md-font-icon="icon-close-circle-outline" class="icon ng-scope ng-isolate-scope md-font icon-close-circle-outline material-icons md-default-theme" aria-hidden="true"></md-icon></button><h2 style="text-align:center;font-weight: bold;">LEGENDA</h2><br><table class="simple" ms-responsive-table ><tbody>' +
          '<tr><td><span style="font-weight: bold;">Dati Catastali</span></td><td><span>Foglio/mappale/subalterno/categoria</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Indirizzo</span></td><td><span>Indirizzo immobili/descrizione</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Quota</span></td><td><span>Quota di possesso</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Mesi</span></td><td><span>Mesi di possesso per l\'anno</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Rendita catastale</span></td><td><span>Rendita catastale fabbricato (o reddito dominicale terreno)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Valore imponibile</span></td><td><span>Valore imponibile oggetto di calcolo su cui applicare aliquota</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Detr ab.pr</span></td><td><span>Detrazione abitazione principale</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Ab.Rd.Es.</span></td><td><span>Flag abitazione principale/riduzione/esenzione</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Comune Aliq-Imposta</span></td><td><span>Aliquota Tributo a favore del Comune</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Stato Aliq-Imposta</span></td><td><span>Aliquota Tributo a favore dello Stato (IMU)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Note</span></td><td><span>Annotazioni</span></td></tr>' +
          '</tbody></table></div>',
        controller: DialogController
      });
    }

    function DialogController($scope, $mdDialog) {
      //nasconde la legenda
      $scope.hideInfo = function() {
        $mdDialog.hide();
      }
    }



    //controllo se devo mostrale la colonna Note
    $scope.checkNotes = function() {
      var show = true;
      for (var i = 0; i < $scope.immobiliImu.length; i++) {
        //console.log($scope.immobiliImu[i].note_immobile);
      }
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.datiAttuali', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.datiAttuali', {
                url    : '/datiAttuali',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/datiAttuali/datiAttuali.html',
                        controller : 'DatiAttualiController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/datiAttuali/');

    }
})();
(function() {
    'use strict';

    angular
      .module('app.datiAttuali')
      .factory('DatiAttualiService', DatiAttualiService);

    /** @ngInject */
    function DatiAttualiService($http, $rootScope, $location, $q) {
      var service = {};

      service.getAllData = function() {

        var param = {
          id_comune: $rootScope.id_comune,
          cf_user: $rootScope.globals.currentUser.username,
          codAna: $rootScope.globals.currentUser.codAna
        };

        var dfd = $q.defer();
        var promise = $http({
          method: 'POST',
          url: $rootScope.serverBasePath + 'anagrafiche/getAllData',
          data: $.param(param),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function successCallback(response) {
          dfd.resolve(response.data);
        });

        $rootScope.loadingTracker.addPromise(promise);
        return dfd.promise;

      };


      service.printF24 = function(callback, param) {
        var promise = $http({
          method: 'POST',
          data: $.param(param),
          url     : $rootScope.serverBasePath + 'anagrafiche/printTotali',
          headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(function successCallback(response) {

          callback(response.data.data,response.data.success);
        });
      };

      service.getDatiAttuali = function(callback, param){

        $http({
            method  : 'POST',
            data: $.param(param),
            url     : $rootScope.serverBasePath + 'anagrafiche/getDatiAttuali',
            headers : { 'Content-Type': 'application/x-www-form-urlencoded' }  // set the headers so angular passing info as form data (not request payload)
        })
        .then(function(response) {
            callback(response.data);

        });
      }


      //prendo id dati relativi ai pagamenti dell'utente
      service.getUserTotals = function() {

        var data = { 'cf_user': $rootScope.globals.currentUser.username, 'id_comune': $rootScope.id_comune};
          var dfd = $q.defer();
          var promise = $http({
              method: 'POST',
              url: $rootScope.serverBasePath + 'users/getUserTotals',
              data: $.param(data),
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(function successCallback(response) {
                  dfd.resolve(response.data);
          });

          $rootScope.loadingTracker.addPromise(promise);
          return dfd.promise;

      };

      //prendo id dati relativi ai pagamenti dell'utente
      service.showNotes = function() {

        var data = { 'id_comune' : $rootScope.id_comune};
          var dfd = $q.defer();
          var promise = $http({
              method: 'POST',
              url: $rootScope.serverBasePath + 'users/showNotes',
              data: $.param(data),
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(function successCallback(response) {
                  dfd.resolve(response.data);
          });

          $rootScope.loadingTracker.addPromise(promise);
          return dfd.promise;

      };

      return service;
    }

  })();

(function() {
  'use strict';

  angular
    .module('app.datiAttuali')
    .controller('DatiAttualiController', DatiAttualiController);

  /** @ngInject */
  function DatiAttualiController($http, $rootScope, $scope, $interval, SettingsService, DTDefaultOptions, DTOptionsBuilder, DTColumnBuilder, $compile, $mdDialog, DatiAttualiService, $filter, Notification) {
    var vm = this;

    //inizializzo per non mostrare nel caso mancassero i dati
    $scope.userTotals = [null, null];

    DatiAttualiService.getAllData().then(function(response) {

      if (response.success) {

        // data elaborazione ----------------------------------------------------
        if (response.data.data_elaborazione) {
          $scope.data_elaborazione = moment(response.data.data_elaborazione).format('DD/MM/YYYY');
        } else {
          Notification.error({
            title: 'Errore',
            message: 'Data di elaborazione non trovata',
            positionY: 'top'
          });
        }

        // totali utente --------------------------------------------------------

        //controllo se ho sia i dati dei pagamenti di TASI che di IMU
        if (response.data.pagamenti_utente.length > 1) {
          $scope.userTotals[0] = response.data.pagamenti_utente[0];
          $scope.userTotals[1] = response.data.pagamenti_utente[1];
        } else {

          //se non li ho entrambi controllo quali ho e avviso che mancano gli altri
          if (response.data.pagamenti_utente[0].pagamenti_utente.tributo == "0") {
            $scope.userTotals[0] = response.data.pagamenti_utente[0];
            Notification.warning({
              title: 'ATTENZIONE',
              message: "I dati relativi al pagamento di 'TASI' non sono stati trovati",
              positionY: 'top'
            });
          } else {
            $scope.userTotals[1] = response.data.pagamenti_utente[0];
            Notification.warning({
              title: 'ATTENZIONE',
              message: "I dati relativi al pagamento di 'IMU' non sono stati trovati",
              positionY: 'top'
            });
          }
        }

        // note immobile --------------------------------------------------------
        if (response.data.note_immobile == true) {
          $scope.booleanNotes = true;
        } else {
          $scope.booleanNotes = false;
        }

        // dati attuali ---------------------------------------------------------
        vm.immobiliImu = response.data.immobiliImu;
        vm.immobiliTasi = response.data.immobiliTasi;
        vm.totali = response.data.totali;

      } else {
        Notification.warning({
          title: 'ATTENZIONE!',
          message: "Errore nel recuperare i dati",
          positionY: 'top'
        });
      }
    });

    //controllo quale tab mostrare
    $scope.checkIMUTASI = function(index) {
      if ($scope.userTotals[index]) {
        return true;
      } else {
        return false;
      }
    }

    //gestione del checkbox per mostrare le note
    $scope.checkBoolean = function() {
      if (angular.isUndefined($scope.booleanNotes) || $scope.booleanNotes == null) {
        return false;
      } else {
        if ($scope.booleanNotes == true) {
          return true;
        } else {
          return false;
        }
      }

    }

    $scope.customStyleWindows = function() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      var trident = ua.indexOf('Trident/');
      var edge = ua.indexOf('Edge/');

      if (msie > 0 || trident > 0 || edge > 0) {
        //console.log("Microsoft");
        var myStyle = {
          "min-width": "30%"
        };
        return myStyle;
      }
    }

    //restituisco i dati in base al campo richiesto
    $scope.getDataFromTotals = function(index) {
      if ($scope.userTotals[0] && !$scope.userTotals[1]) {
        switch (index) {
          case 0:
            return $scope.userTotals[0].pagamenti_utente.totale;
            break;
          case 1:
            return $scope.userTotals[0].pagamenti_utente.versato;
            break;
          case 2:
            return $scope.userTotals[0].pagamenti_utente.differenza;
            break;
          default:
            break;

        }
      } else if (!$scope.userTotals[0] && $scope.userTotals[1]) {
        switch (index) {
          case 3:
            return $scope.userTotals[1].pagamenti_utente.totale;
            break;
          case 4:
            return $scope.userTotals[1].pagamenti_utente.versato;
            break;
          case 5:
            return $scope.userTotals[1].pagamenti_utente.differenza;
            break;

          default:
            break;
        }
      } else {
        switch (index) {
          case 0:
            return $scope.userTotals[0].pagamenti_utente.totale;
            break;
          case 1:
            return $scope.userTotals[0].pagamenti_utente.versato;
            break;
          case 2:
            return $scope.userTotals[0].pagamenti_utente.differenza;
            break;
          case 3:
            return $scope.userTotals[1].pagamenti_utente.totale;
            break;
          case 4:
            return $scope.userTotals[1].pagamenti_utente.versato;
            break;
          case 5:
            return $scope.userTotals[1].pagamenti_utente.differenza;
            break;

          default:
            break;

        }
      }
    }

    $scope.showNotes = function() {

    }

    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      bFilter: false,
      bInfo: false,
      bSort: false,
      responsive: true
    };

    var getDatiAttuali = function() {
      $scope.param = {
        'codAna': $rootScope.globals.currentUser.codAna,
        'codFisc': $rootScope.globals.currentUser.username,
        'id_comune': $rootScope.id_comune
      };
      DatiAttualiService.getDatiAttuali(function(response) {
        vm.immobiliImu = response.immobiliImu;
        vm.immobiliTasi = response.immobiliTasi;
        vm.totali = response.totali;
      }, $scope.param);
    }


    $scope.printF24 = function(tipo) {
      $scope.param = {
        'codAna': $rootScope.globals.currentUser.codAna,
        'codFisc': $rootScope.globals.currentUser.username,
        'id_comune': $rootScope.id_comune,
        'tipo': tipo
      };

      var nomeTipo = "Saldo";
      if (tipo == "A")
        nomeTipo = "Acconto";

      DatiAttualiService.printF24(function(response, success) {
        if (success) {
          if (document.location.hostname != "localhost")
            var fileURL = $rootScope.serverBasePath + 'webroot/' + response;
          else var fileURL = 'http://localhost/portale-imu-server/webroot/' + response;

          var a = document.createElement('a');
          a.href = fileURL;
          a.target = '_blank';
          a.download = response;
          document.body.appendChild(a);
          a.click();
        } else {
          Notification.error({
            title: 'Attenzione',
            message: 'Non è presente nessun ' + nomeTipo,
            positionY: 'top'
          });
        }


      }, $scope.param);
    }

    $scope.printImu = function() {

      var doc = new jsPDF({
        orientation: 'landscape'
      });

      doc.setFontSize(10);
      //doc.text('ELENCO IMMOBILI IMU ' + $rootScope.globals.currentUser.nome, 10, 15);
      if ($scope.checkBoolean()) {
        var columns = ["Dati Catastali", "Indirizzo", "% Quota", "Mesi", "Rendita catastale", "Valore imponibile", "Detr ab.pr", "Ab.Rd.Es.", "Comune Aliq-Imposta", "Stato Aliq-Imposta", "Note"];
      } else {
        var columns = ["Dati Catastali", "Indirizzo", "% Quota", "Mesi", "Rendita catastale", "Valore imponibile", "Detr ab.pr", "Ab.Rd.Es.", "Comune Aliq-Imposta", "Stato Aliq-Imposta"];
      }
      var rows = [];
      for (var i = 0; i < vm.immobiliImu.length; i++) {
        if ($scope.checkBoolean()) {
          rows.push([
            vm.immobiliImu[i].immobili.foglio + "/" + vm.immobiliImu[i].immobili.mappale + "/" + vm.immobiliImu[i].immobili.subalterno + "-" + vm.immobiliImu[i].immobili.cat,
            vm.immobiliImu[i].immobili.indirizzo + " " + vm.immobiliImu[i].immobili.civico,
            vm.immobiliImu[i].immobili.perc,
            vm.immobiliImu[i].immobili.mesi,
            vm.immobiliImu[i].immobili.rendita,
            vm.immobiliImu[i].immobili.valore,
            vm.immobiliImu[i].immobili.detrazione,
            vm.immobiliImu[i].immobili.abpr + "-" + vm.immobiliImu[i].immobili.rid + "-" + vm.immobiliImu[i].immobili.ese,
            vm.immobiliImu[i].immobili.al_comune + "-" + vm.immobiliImu[i].immobili.imp_comune,
            vm.immobiliImu[i].immobili.al_stato + "-" + vm.immobiliImu[i].immobili.imu_stato,
            vm.immobiliImu[i].immobili.note_immobile
          ]);
        } else {
          rows.push([
            vm.immobiliImu[i].immobili.foglio + "/" + vm.immobiliImu[i].immobili.mappale + "/" + vm.immobiliImu[i].immobili.subalterno + "-" + vm.immobiliImu[i].immobili.cat,
            vm.immobiliImu[i].immobili.indirizzo + " " + vm.immobiliImu[i].immobili.civico,
            vm.immobiliImu[i].immobili.perc,
            vm.immobiliImu[i].immobili.mesi,
            vm.immobiliImu[i].immobili.rendita,
            vm.immobiliImu[i].immobili.valore,
            vm.immobiliImu[i].immobili.detrazione,
            vm.immobiliImu[i].immobili.abpr + "-" + vm.immobiliImu[i].immobili.rid + "-" + vm.immobiliImu[i].immobili.ese,
            vm.immobiliImu[i].immobili.al_comune + "-" + vm.immobiliImu[i].immobili.imp_comune,
            vm.immobiliImu[i].immobili.al_stato + "-" + vm.immobiliImu[i].immobili.imu_stato
          ]);
        }

      }

      doc.autoTable(columns, rows, {
        theme: 'grid',
        styles: {
          fontSize: 8
        },
        headerStyles: {
          fillColor: [169, 169, 169]
        },
        margin: {
          top: 25
        },
        addPageContent: function(data) {
          doc.text('ELENCO IMMOBILI IMU ' + $rootScope.globals.currentUser.nome, 10, 15);
        }
      });
      doc.save('ImmobiliImu.pdf');
    }

    $scope.printTasi = function() {

      var doc = new jsPDF({
        orientation: 'landscape'
      });

      doc.setFontSize(10);
      var columns = ["Dati Catastali", "Indirizzo", "% Quota", "Mesi", "Rendita catastale", "Valore imponibile", "Detr ab.pr", "Ab.Rd.Es.", "Comune Aliq-Imposta", "Stato Aliq-Imposta", "Note"];
      var rows = [];
      for (var i = 0; i < vm.immobiliTasi.length; i++) {
        rows.push([
          vm.immobiliTasi[i].immobili.foglio + "/" + vm.immobiliTasi[i].immobili.mappale + "/" + vm.immobiliTasi[i].immobili.subalterno + "-" + vm.immobiliTasi[i].immobili.cat,
          vm.immobiliTasi[i].immobili.indirizzo + " " + vm.immobiliTasi[i].immobili.civico,
          vm.immobiliTasi[i].immobili.perc,
          vm.immobiliTasi[i].immobili.mesi,
          vm.immobiliTasi[i].immobili.rendita,
          vm.immobiliTasi[i].immobili.valore,
          vm.immobiliTasi[i].immobili.detrazione,
          vm.immobiliTasi[i].immobili.abpr + "-" + vm.immobiliTasi[i].immobili.rid + "-" + vm.immobiliTasi[i].immobili.ese,
          vm.immobiliTasi[i].immobili.al_comune + "-" + vm.immobiliTasi[i].immobili.imp_comune,
          vm.immobiliTasi[i].immobili.al_stato + "-" + vm.immobiliTasi[i].immobili.imu_stato,
          vm.immobiliTasi[i].immobili.note_immobile
        ]);
      }

      doc.autoTable(columns, rows, {
        theme: 'grid',
        styles: {
          fontSize: 8
        },
        headerStyles: {
          fillColor: [169, 169, 169]
        },
        margin: {
          top: 25
        },
        addPageContent: function(data) {
          doc.text('ELENCO IMMOBILI TASI ' + $rootScope.globals.currentUser.nome, 10, 15);
        }
      });
      doc.save('immobiliTasi.pdf');
    }


    //mostra la legenda premendo sul pulsante i (F24)
    $scope.showInfoF24 = function() {
      $mdDialog.show({
        //targetEvent: $event,
        fullscreen: false,
        template: '<div style="padding:25px;position: relative;"> <button class="btn btn-warning" ng-click="hideInfo()" style="position: absolute;right:25px;top:25px;"><md-icon md-font-icon="icon-close-circle-outline" class="icon ng-scope ng-isolate-scope md-font icon-close-circle-outline material-icons md-default-theme" aria-hidden="true"></md-icon></button><h2 style="text-align:center;font-weight: bold;">LEGENDA</h2><br><table class="simple" ms-responsive-table ><tbody>' +
          '<tr><td><span style="font-weight: bold;">Acc saldo</span></td><td><span>Acconto (A) o Saldo (S)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">EL</span></td><td><span>Colonna modello F24 vale Enti Locali (EL)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Ente</span></td><td><span>Codice catasto del Comune</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Codtr</span></td><td><span>Codice tributo</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">NR</span></td><td><span>Numero immobili</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Detrazione</span></td><td><span>Detrazione abitazione principale</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Importo</span></td><td><span>Importo da versare in acconto a saldo</span></td></tr>' +
          '</tbody></table></div>',
        controller: DialogController
      });
    }

    //mostra la legenda premendo sul pulsante i
    $scope.showInfo = function() {
      $mdDialog.show({
        //targetEvent: $event,
        fullscreen: false,
        template: '<div style="padding:25px;position: relative;"> <button class="btn btn-warning" ng-click="hideInfo()" style="position: absolute;right:25px;top:25px;"><md-icon md-font-icon="icon-close-circle-outline" class="icon ng-scope ng-isolate-scope md-font icon-close-circle-outline material-icons md-default-theme" aria-hidden="true"></md-icon></button><h2 style="text-align:center;font-weight: bold;">LEGENDA</h2><br><table class="simple" ms-responsive-table ><tbody>' +
          '<tr><td><span style="font-weight: bold;">Dati Catastali</span></td><td><span>Foglio/mappale/subalterno/categoria</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Indirizzo</span></td><td><span>Indirizzo immobili/descrizione</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Quota</span></td><td><span>Quota di possesso</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Mesi</span></td><td><span>Mesi di possesso per l\'anno</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Rendita catastale</span></td><td><span>Rendita catastale fabbricato (o reddito dominicale terreno)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Valore imponibile</span></td><td><span>Valore imponibile oggetto di calcolo su cui applicare aliquota</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Detr ab.pr</span></td><td><span>Detrazione abitazione principale</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Ab.Rd.Es.</span></td><td><span>Flag abitazione principale/riduzione/esenzione</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Comune Aliq-Imposta</span></td><td><span>Aliquota Tributo a favore del Comune</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Stato Aliq-Imposta</span></td><td><span>Aliquota Tributo a favore dello Stato (IMU)</span></td></tr>' +
          '<tr><td><span style="font-weight: bold;">Note</span></td><td><span>Annotazioni</span></td></tr>' +
          '</tbody></table></div>',
        controller: DialogController
      });
    }

    function DialogController($scope, $mdDialog) {
      //nasconde la legenda
      $scope.hideInfo = function() {
        $mdDialog.hide();
      }
    }



    //controllo se devo mostrale la colonna Note
    $scope.checkNotes = function() {
      var show = true;
      for (var i = 0; i < vm.immobiliImu.length; i++) {
        //console.log(vm.immobiliImu[i].note_immobile);
      }
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cambiopassword', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.cambiopassword', {
                url    : '/cambiopassword',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cambioPassword/cambioPassword.html',
                        controller : 'CambioPasswordController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/cambiopassword/');

    }
})();

(function() {
    'use strict';

    angular
      .module('app.cambiopassword')
      .factory('CambioPasswordService', CambioPasswordService);

    /** @ngInject */
    function CambioPasswordService($http, $rootScope, $location, $q) {
      var service = {};



      return service;
    }

  })();

(function() {
    'use strict';

    angular
        .module('app.cambiopassword')
        .controller('CambioPasswordController', CambioPasswordController);

    /** @ngInject */
    function CambioPasswordController($http, $rootScope, $scope, $interval, $compile, $mdDialog, $filter, Notification, AuthenticationService) {
        var vm = this;

        $scope.password = "";
        $scope._password = "";
        $scope.check = true;

        $scope.checkPswA = function() {
            if ($scope.password.length > 0) {
                if (/^\w+$/.test($scope.password)) {
                    $scope.check = false;
                } else {
                    $scope.check = true;
                }
            }

        }

        $scope.checkPswB = function() {
            if ($scope._password.length > 0) {
                if (/^\w+$/.test($scope._password)) {
                    $scope.check = false;
                } else {
                    $scope.check = true;
                }
            }

        }

        $scope.changePassword = function() {
            AuthenticationService.changePassword($scope.password, function(resp) {
                if (resp) {
                    Notification.success({
                        title: '',
                        message: "Password salvata",
                        positionY: 'top'
                    });
                } else {
                    Notification.error({
                        title: 'Attenzione',
                        message: "Errore durante il salvataggio",
                        positionY: 'top'
                    });
                }

            })
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.anagrafiche', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.anagrafiche', {
                url    : '/anagrafiche',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/anagrafiche/anagrafiche.html',
                        controller : 'AnagraficheController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/anagrafiche/');

    }
})();
(function () {
  'use strict';

  angular
    .module('app.anagrafiche')
    .controller('DetailsDialogController', DetailsDialogController);

  /** @ngInject */
  function DetailsDialogController($scope, AnagraficaService, codAna, $mdDialog, Notification) {
    var vm = this;

    $scope.email = '';
    $scope.phone = '';

    var getDetails = function () {
      AnagraficaService.getDetails(function (response) {
        console.info('response', response);
        $scope.selectedUser = response;

        $scope.email = response.userData.users.email ? response.userData.users.email : (response.anagrafica.bol_mail ? response.anagrafica.bol_mail : '');
        $scope.phone = response.userData.users.email ? response.userData.users.cellulare : (response.anagrafica.bol_cell ? response.anagrafica.bol_cell : '');

      }, codAna);
    }

    getDetails();

    $scope.cancel = function ($event) {
      $mdDialog.cancel();
    };

    $scope.save = function (email, phone) {

      console.log(email, phone);

      var params = {
        username: $scope.selectedUser.anagrafica.cod_fiscale,
        email: email ? email : '',
        phone: phone ? phone : '',
        id_comune: $scope.selectedUser.anagrafica.id_comune
      }

      AnagraficaService.editInfo(function (response) {

        console.log(response);

        if (response.success) {
          Notification.success({
            title: 'FATTO!',
            message: 'Dati modificati con successo',
            positionY: 'top'
          });
        } else {
          Notification.error({
            title: 'Errore',
            message: 'Impossibile completare l\'operazione',
            positionY: 'top'
          });
        }

      }, params);

    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.anagrafiche')
    .factory('AnagraficaService', AnagraficaService);

  /** @ngInject */
  function AnagraficaService($http, $rootScope, $location) {
    var service = {};

    service.getDetails = function (callback, codAna) {
      var param = {
        'codAna': codAna,
        'id_comune': $rootScope.id_comune
      };
      var promise = $http({
        method: 'POST',
        data: $.param(param),
        url: $rootScope.serverBasePath + 'anagrafiche/getUserDetails',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function successCallback(response) {
        callback(response.data.data);
      });
    };

    service.resetPassword = function (callback, param) {

      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'users/resetPassword',
        data: $.param(param),
        // set the headers so angular passing info as form data (not request payload)
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        callback(response.data.data);
      });

    }

    service.bloccaUtente = function (callback, param) {

      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'anagrafiche/getAnagraficheTotal', //TODO servizio da implementare
        data: $.param(param),
        // set the headers so angular passing info as form data (not request payload)
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        callback(response.data);
      });
    }

    /** get anagrafica paginated */
    service.getTotal = function (callback, param) {
      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'anagrafiche/getAnagraficheTotal',
        data: $.param(param),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        callback(response.data);
      });
    }

    /** edit user details */
    service.editInfo = function (callback, param) {
      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'anagrafiche/editUserInfo',
        data: $.param(param),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        callback(response.data);
      });
    }

    return service;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.anagrafiche')
    .controller('AnagraficheController', AnagraficheController);

  /** @ngInject */
  function AnagraficheController($http, $rootScope, $scope, $interval, DTDefaultOptions, DTOptionsBuilder, DTColumnBuilder, $compile, $mdDialog, AnagraficaService, Notification) {
    var vm = this;

    DTDefaultOptions.setDisplayLength(50);

    $scope.param = {
      comune: $rootScope.globals.currentUser.comune,
      id_comune: $rootScope.id_comune,
      total: 1000
    };

    AnagraficaService.getTotal(function (response) {

      if (response.success) {
        $scope.param.total = response.data.number;
        vm.reloadData = reloadData;
      } else {
        Notification.warning({
          title: 'ATTENZIONE',
          message: 'Errore durante la ricezione dei dati',
          positionY: 'top'
        });
      }


    }, $scope.param)

    /*********** SERVER SIDE PAGINATION *************/

    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('ajax', {
        dataSrc: "data",
        data: $scope.param,
        url: $rootScope.serverBasePath + 'anagrafiche/getAnagrafichePaginated',
        type: 'POST'
      })
      .withOption('processing', true) //for show progress bar
      .withOption('serverSide', true) // for server side processing
      .withOption('searchDelay', 1500) // for server side processing
      .withOption('order', [0, 'asc'])
      .withOption('createdRow', createdRow)
      .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
      .withPaginationType('simple');

    vm.dtColumns = [
      DTColumnBuilder.newColumn('anagrafica.cognome').withTitle('COGNOME'),
      DTColumnBuilder.newColumn('anagrafica.nome').withTitle('NOME'),
      //DTColumnBuilder.newColumn(null).withTitle('INDIRIZZO').renderWith(buildAddress),
      DTColumnBuilder.newColumn('anagrafica.cod_fiscale').withTitle('CODICE FISCALE'),
      DTColumnBuilder.newColumn(null).withTitle('DOCUMENTO').notSortable().renderWith(documentButton),
      DTColumnBuilder.newColumn(null).withTitle('STATO UTENTE').renderWith(stateButton),
      DTColumnBuilder.newColumn(null).withTitle('DETTAGLI').notSortable().renderWith(detailsButton),
      DTColumnBuilder.newColumn(null).withTitle('AZIONI').notSortable().renderWith(actionsButton)
    ];

    // vm.reloadData = reloadData;
    vm.dtInstance = {};

    // Methods

    function createdRow(row, data, dataIndex) {
      $compile(angular.element(row).contents())($scope);
    }

    function reloadData() {
      var resetPaging = false;
      vm.dtInstance.reloadData(null, resetPaging);
    }

    function isImage(name) {
      return (
        name.includes(".jfif") ||
        name.includes(".jfif-tbnl") ||
        name.includes(".jpe") ||
        name.includes(".jpeg") ||
        name.includes(".jpg") ||
        name.includes(".gif") ||
        name.includes(".png") ||
        name.includes(".x-png")
      )
    }

    $scope.showAttachment = function (media) {
      var imgPath = null;
      if (document.location.hostname != "localhost") {
        imgPath = $rootScope.serverBasePath + 'webroot/upload/documenti/' + $rootScope.id_comune + '/' + media;
      } else {
        imgPath = 'http://localhost/portale-imu-server/webroot/upload/documenti/' + $rootScope.id_comune + '/' + media;
      }

      var template = null;

      if (isImage(media)) {
        template = '<img style="height:900px;" src="' + imgPath + '" />';
      } else if (media.includes(".pdf")) {
        template = ' <iframe src="' + imgPath + '" width="600px" height="900px">';
      } else {
        Notification.warning({
          title: 'ATTENZIONE',
          message: 'Formato non riconosciuto',
          positionY: 'top'
        });
      }

      if(template != null){
        $mdDialog.show({
          template: template,
          parent: angular.element(document.body),
          clickOutsideToClose: true
        });
      }

    };



    $scope.resetPassword = function (codFiscale) {

      $scope.param = {
        'username': codFiscale,
        'id_comune': $rootScope.id_comune
      };
      AnagraficaService.resetPassword(function (response) {
        if (response.success) {
          Notification.success({
            title: 'OPERAZIONE EFFETTUATA',
            message: 'Password rigenerata con successo',
            positionY: 'top'
          });
        } else {
          Notification.warning({
            title: 'ATTENZIONE',
            message: response.message,
            positionY: 'top'
          });
        }

      }, $scope.param);
    }

    $scope.bloccaUtente = function (codAna) {

      $scope.param = {
        'cod_ana': codAna,
        'id_comune': $rootScope.id_comune
      };
      AnagraficaService.bloccaUtente(function (response) {
        Notification.success({
          title: 'OPERAZIONE EFFETTUATA',
          message: 'Utente bloccato con successo',
          positionY: 'top'
        });
        reloadData();
      }, $scope.param);

    }

    $scope.showDetails = function (codAna) {

      //var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;

      $mdDialog.show({
        controller: 'DetailsDialogController',
        templateUrl: 'app/main/anagrafiche/details-dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        preserveScope: false,
        locals: {
          codAna: codAna
        },
        onRemoving: function (event, removePromise) {
          reloadData();
        }
      });
    }

    function buildAddress(data, type, full) {
      var address = '<address>' + data.anagrafica.indirizzo + ' ' + data.anagrafica.civico;

      return address;

    }

    function documentButton(data) {
      var showRetroButton = false;
      if (data.users.doc_retro) {
        showRetroButton = true;
      }

      if (data.users.doc) {
        return '<button class="btn btn-warning" ng-click="showAttachment(\'' + data.users.doc + '\')">' +
          '<md-icon md-font-icon="icon-file-outline" class="icon ng-scope ng-isolate-scope md-font icon-file-outline material-icons md-default-theme" style="color:blue; aria-hidden="true"></md-icon>' +
          '</button>' +
          '<button class="btn btn-warning" ng-show="' + showRetroButton + '" ng-click="showAttachment(\'' + data.users.doc_retro + '\')">' +
          '<md-icon md-font-icon="icon-file-outline" class="icon ng-scope ng-isolate-scope md-font icon-file-outline material-icons md-default-theme" style="color:blue; aria-hidden="true"></md-icon>' +
          '</button>';
      } else {
        return '';
      }


    }

    function stateButton(data) {

      //console.log(data.anagrafica);
      if (data.users.password != null && data.users.flag_attivo) {
        return '<div>' +
          '<md-icon md-font-icon="icon-account-check" class="icon ng-scope ng-isolate-scope md-font icon-account-check material-icons md-default-theme" style="color:green;" aria-hidden="true"></md-icon>' +
          '<md-tooltip md-direction="bottom">Utente Registrato</md-tooltip>' +
          '</div>';
      } else if (data.users.password != null && !data.users.flag_attivo) {
        return '<div>' +
          '<md-icon md-font-icon="icon-account-alert" class="icon ng-scope ng-isolate-scope md-font icon-account-alert material-icons md-default-theme" style="color:orange;" aria-hidden="true"></md-icon>' +
          '<md-tooltip md-direction="bottom">Utente bloccato o in attesa di conferma</md-tooltip>' +
          '</div>';
      }

      return '';

    }


    function detailsButton(data) {

      $scope.currentUser = data;

      return '<button class="btn btn-warning" ng-click="showDetails(\'' + data.anagrafica.cod_ana + '\')">' +
        '<md-icon md-font-icon="icon-document" class="icon ng-scope ng-isolate-scope md-font icon-document material-icons md-default-theme" aria-hidden="true"></md-icon>' +
        '</button>';

    }

    function actionsButton(data) {

      if (data.users.password != null && data.users.flag_attivo) {

        return '<button class="btn btn-warning" ng-click="resetPassword(\'' + data.anagrafica.cod_fiscale + '\')">' +
          '<md-icon md-font-icon="icon-key-variant" class="icon ng-scope ng-isolate-scope md-font icon-key-variant material-icons md-default-theme" style="margin-right: 15px;" aria-hidden="true"></md-icon>' +
          '<md-tooltip md-direction="bottom">Rigenera Password</md-tooltip>' +
          '</button>' +
          '<button class="btn btn-warning" ng-click="bloccaUtente(' + data.anagrafica.cod_ana + ')">' +
          '<md-icon md-font-icon="icon-block-helper" class="icon ng-scope ng-isolate-scope md-font icon-block-helper material-icons md-default-theme" aria-hidden="true"></md-icon>' +
          '<md-tooltip md-direction="bottom">Blocca accesso login</md-tooltip>' +
          '</button>';
      } else {
        return '';
      }

    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.accessi', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.accessi', {
                url    : '/accessi',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/accessi/accessi.html',
                        controller : 'AccessiController as vm'
                    }
                },
                resolve: {}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/accessi/');

    }
})();
(function() {
    'use strict';

    angular
      .module('app.accessi')
      .factory('AccessiService', AccessiService);

    /** @ngInject */
    function AccessiService($http, $rootScope, $location) {
      var service = {};

      service.getInfoComune = function(callback) {
        var param = {'id_comune': $rootScope.id_comune};
        var promise = $http({
          method: 'POST',
          data: $.param(param),
          url     : $rootScope.serverBasePath + 'settings/getInfoComune',
          headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(function successCallback(response) {
          callback(response.data.data);
        });
      };

      return service;
    }

  })();

(function ()
{
    'use strict';

    angular
        .module('app.accessi')
        .controller('AccessiController', AccessiController);

    /** @ngInject */
    function AccessiController($http,$rootScope,$scope,$interval,DTDefaultOptions,DTOptionsBuilder,DTColumnBuilder,$compile,AccessiService, $filter)
    {
        var vm = this;

        vm.dataInizio = new Date();
        vm.dataFine = new Date();

        function buildSearchData(){
            return $scope.queryParams = {
                'dataInizio': $filter('date')(vm.dataInizio,'yyyy-MM-dd'),
                'dataFine': $filter('date')(vm.dataFine,'yyyy-MM-dd'),
                'comune': $rootScope.globals.currentUser.comune,
                'id_comune': $rootScope.id_comune
            }
        }


        // Display 50 items per page by default
         DTDefaultOptions.setDisplayLength(50);

         vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {

                // Either you specify the AjaxDataProp here
                url: $rootScope.serverBasePath + 'users/getAccessi',
                data    : buildSearchData,
                type: 'POST'
            })
            .withOption('order', [ 1, 'asc' ])
            .withOption('createdRow', createdRow)
            .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withPaginationType('simple');

        vm.dtColumns = [

            DTColumnBuilder.newColumn('anagrafica.cognome').withTitle('COGNOME'),
            DTColumnBuilder.newColumn('anagrafica.nome').withTitle('NOME'),
            DTColumnBuilder.newColumn('anagrafica.cod_fiscale').withTitle('CODICE FISCALE'),
            DTColumnBuilder.newColumn('accessi.data_login').withTitle('GIORNO').renderWith(getDate).withOption('type', 'date-nl'),
            DTColumnBuilder.newColumn('accessi.time_login').withTitle('ORA LOGIN'),
        ];
        vm.reloadData = reloadData;
        vm.dtInstance = {};


        // Methods

        jQuery.extend( jQuery.fn.dataTableExt.oSort, {
            "date-nl-pre": function ( date ) {
              //console.log(moment(date, 'dddd, MMMM Do, YYYY').format('DD-MM-YYYY'));
              return moment(date, 'DD, MM, YYYY');
            },

            "date-nl-asc": function ( a, b ) {
              return (a.isBefore(b) ? -1 : (a.isAfter(b) ? 1 : 0));
            },

            "date-nl-desc": function ( a, b ) {
              return (a.isBefore(b) ? 1 : (a.isAfter(b) ? -1 : 0));
            }
          });


        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            //else ng-click on button DONT WORKS
            $compile(angular.element(row).contents())($scope);
        }

        function reloadData() {
            var resetPaging = false;
            vm.dtInstance.reloadData(callback, resetPaging);
        }

        function getDate(data){
            return $filter('date')(data,'dd-MM-yyyy');
        }

        $scope.searcAccess = function(){
            /* console.info('vm.dataInizio', $filter('date')(vm.dataInizio,'yyyy-MM-dd'));
            buildSearchData() */
            vm.dtInstance.rerender();
        }

        function callback(json) {

        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $scope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $cookies)
    {
        var vm = this;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        //vm.logout = logout;
        $scope.sourceLogo = "assets/images/" + $rootScope.globals.currentUser.comune.toLowerCase() + ".bmp";
        
        //console.info('$scope.sourceLogo', $scope.sourceLogo);

        //////////

/*         init();

        function init()
        {
            if($rootScope.globals.currentUser.role == 0){
                vm.bar_user = $rootScope.globals.currentUser.username;
            }else{
                vm.bar_user = $rootScope.globals.currentUser.nome;
            }
            
        } */

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
/*         function logout()
        {
          $rootScope.globals = null;
          $cookies.remove('user');
          $state.go('app.login');
        } */

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.register', {
            url      : '/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.register': {
                    templateUrl: 'app/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

/*         // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.register',
            weight: 3
        }); */
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($http,$rootScope,$scope,$filter,FileUploader,Notification)
    {
        // Data
        var uploader = $scope.uploader = new FileUploader({url: $rootScope.serverBasePath + 'users/uploadDocument', method: 'POST', queue: []});
        var retroUploader = $scope.retroUploader = new FileUploader({url: $rootScope.serverBasePath + 'users/uploadDocument', method: 'POST', queue: []});
        $scope.showForm = true;

        //--------------------------------UPLOADER PETHODS
        uploader.filters.push({
            name: 'syncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {

                return this.queue.length < 10;
            }
        });

        // an async filter
        uploader.filters.push({
            name: 'asyncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options, deferred) {

                setTimeout(deferred.resolve, 1e3);
            }
        });

        uploader.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                return item.size <= 2097152; // 2 MB to bytes
            }
        });

        retroUploader.filters.push({
            name: 'syncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {

                return this.queue.length < 10;
            }
        });

        // an async filter
        retroUploader.filters.push({
            name: 'asyncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options, deferred) {

                setTimeout(deferred.resolve, 1e3);
            }
        });

        retroUploader.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                return item.size <= 2097152; // 2 MB to bytes
            }
        });

        // CALLBACKS

        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            $scope.errorLimit = true;
            document.getElementById("uploadFile").value = "";
            //console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            $scope.errorLimit = false;
            //console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            //console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            //console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            //console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            //console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            //console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            //console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            //console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            //console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            //console.info('onCompleteAll');
        };

        retroUploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            $scope.errorLimit = true;
            document.getElementById("uploadFile").value = "";
            //console.info('onWhenAddingFileFailed', item, filter, options);
        };
        retroUploader.onAfterAddingFile = function(fileItem) {
            $scope.errorLimit = false;
            //console.info('onAfterAddingFile', fileItem);
        };
        retroUploader.onAfterAddingAll = function(addedFileItems) {
            //console.info('onAfterAddingAll', addedFileItems);
        };

        retroUploader.onBeforeUploadItem = function(item) {
            //console.info('onBeforeUploadItem', item);
        };
        retroUploader.onProgressItem = function(fileItem, progress) {
            //console.info('onProgressItem', fileItem, progress);
        };
        retroUploader.onProgressAll = function(progress) {
            //console.info('onProgressAll', progress);
        };
        retroUploader.onSuccessItem = function(fileItem, response, status, headers) {
            //console.info('onSuccessItem', fileItem, response, status, headers);
        };
        retroUploader.onErrorItem = function(fileItem, response, status, headers) {
            //console.info('onErrorItem', fileItem, response, status, headers);
        };
        retroUploader.onCancelItem = function(fileItem, response, status, headers) {
            //console.info('onCancelItem', fileItem, response, status, headers);
        };
        retroUploader.onCompleteItem = function(fileItem, response, status, headers) {
            //console.info('onCompleteItem', fileItem, response, status, headers);
        };
        retroUploader.onCompleteAll = function() {
            //console.info('onCompleteAll');
        };

        $scope.deleteItem = function(){
            document.getElementById("uploadFile").value = "";
            uploader.queue.pop();
        }

        $scope.deleteRetroItem = function(){
            document.getElementById("uploadRetro").value = "";
            retroUploader.queue.pop();
        }

        //-------------------------------------------------

        $scope.createUser = function(){
            $scope.param = {
                'codiceFiscale':$scope.codiceFiscale.toUpperCase(),
                'numeroTelefono':$scope.numeroTelefono,
                'email':$scope.email,
                'id_comune': $rootScope.id_comune
            };
            //console.log($scope.param);
             var promise = $http({
                method: 'POST',
                url: $rootScope.serverBasePath + 'users/createUser',
                data: $.param($scope.param),
                // set the headers so angular passing info as form data (not request payload)
                headers : { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function(response) {
                //console.info('response', response);
                if(response.data.success){

                    $scope.uploader.queue[0].formData.push({'idUser' : response.data.data.users.id, 'type':0, 'id_comune': $rootScope.id_comune});

                    $scope.uploader.queue[0].upload();
                    if($scope.retroUploader.queue[0]){
                        $scope.retroUploader.queue[0].formData.push({'idUser' : response.data.data.users.id, 'type':1, 'id_comune': $rootScope.id_comune});

                        $scope.retroUploader.queue[0].upload();
                    }
                    $scope.showForm = false;
                }else{
                    Notification.warning({
                        title: 'ATTENZIONE!',
                        message: response.data.message,
                        positionY: 'top'
                    });
                }
            });
            $rootScope.loadingTracker.addPromise(promise);
        }

       //////////
    }
})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            'app.login',

            'app.register',

            'app.forgot-password',
            // Sample
            'app.settings',

            'app.registrationRequest',

            'app.anagrafiche',

            'app.datiAttuali',

            'app.datiStorici',

            'app.infoComune',

            'app.cambiopassword',

            'app.accessi'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, msNavigationService, AuthenticationService) {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function(event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        msNavigationService.saveItem('fuse', {
            title: '',
            group: true,
            weight: 1
        });

        //select modules to load
        if ($rootScope.globals && $rootScope.globals.currentUser.role == 0) {

            msNavigationService.saveItem('fuse.settings', {
                title: 'SETTINGS',
                icon: 'icon-cog',
                state: 'app.settings',
                translate: 'SETTINGS.SETTINGS_NAV',
                weight: 1
            });

            msNavigationService.saveItem('fuse.registrationRequest', {
                title: 'REGISTRATION',
                icon: 'icon-account-multiple-plus',
                state: 'app.registrationRequest',
                translate: 'REGISTRATION.REGISTRATION_NAV',
                weight: 1
            });

            msNavigationService.saveItem('fuse.anagrafiche', {
                title: 'ANAGRAFICHE',
                icon: 'icon-account',
                state: 'app.anagrafiche',
                translate: 'ANAGRAFICHE.ANAGRAFICHE_NAV',
                weight: 1
            });
            msNavigationService.saveItem('fuse.accessi', {
                title: 'ACCESSI',
                icon: 'icon-login',
                state: 'app.accessi',
                translate: 'ACCESSI.ACCESSI_NAV',
                weight: 1
            });

            msNavigationService.deleteItem('fuse.datiAttuali');
            msNavigationService.deleteItem('fuse.datiStorici');
            msNavigationService.deleteItem('fuse.infoComune');
            msNavigationService.deleteItem('fuse.cambiopassword');

        } else if ($rootScope.globals && $rootScope.globals.currentUser.role == 1) {

            msNavigationService.saveItem('fuse.infoComune', {
                title: 'INFO_COMUNE',
                icon: 'icon-information-outline',
                state: 'app.infoComune',
                translate: 'INFO_COMUNE.INFO_COMUNE_NAV',
                weight: 1
            });


            AuthenticationService.GetCurrentYear().then(function(data) {
                if (data) {
                    //console.log("currentYear: " + data);

                    $rootScope.globals.currentYear = data;
                    msNavigationService.saveItem('fuse.datiAttuali', {
                        title: 'DATI ANNO ' + data,
                        icon: 'icon-file-document',
                        state: 'app.datiAttuali',
                        //translate: 'DATI_ATTUALI.DATI_ATTUALI_NAV',
                        weight: 2
                    });
                }

                msNavigationService.saveItem('fuse.datiStorici', {
                    title: 'DATI STORICI',
                    icon: 'icon-calendar-multiple',
                    state: 'app.datiStorici',
                    weight: 3
                });

                msNavigationService.saveItem('fuse.cambiopassword', {
                    title: 'CAMBIO PASSWORD',
                    icon: 'icon-lock',
                    state: 'app.cambiopassword',
                    // translate: 'INFO_COMUNE.INFO_COMUNE_NAV',
                    weight: 4
                });
            });

            msNavigationService.deleteItem('fuse.settings');
            msNavigationService.deleteItem('fuse.registrationRequest');
            msNavigationService.deleteItem('fuse.anagrafiche');
            msNavigationService.deleteItem('fuse.accessi');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($rootScope, $scope, $state, $cookies) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.logout = logout;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    function logout() {
      $rootScope.globals = null;
      $cookies.remove('user');
      $state.go('app.login');
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function() {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });

  }

})();

(function ()
{
    'use strict';

    angular.module('app.login', ['ui-notification', 'ajoslin.promise-tracker']);

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $mdDialog, promiseTracker)
    {   

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        $rootScope.loadingTracker = promiseTracker();

        
        $rootScope.$watch($rootScope.loadingTracker.active, function (isActive) {
            //console.info(isActive);
            if(isActive)
                $mdDialog.show({
                    template: '<md-dialog style="width:50%;background-color:transparent;box-shadow:none;overflow: hidden;">' +
                        '<div layout="row" layout-sm="column" layout-align="center center" aria-label="wait">' +
                        //'<md-progress-linear id="toolbar-progress" ng-show="true" md-mode="indeterminate" style="/*position: absolute;top: 50%;left: 30%;z-index: 9999;*/"></md-progress-linear>' +
                        '<md-progress-circular id="toolbar-progress" class="md-accent" md-mode="indeterminate" md-diameter="128"></md-progress-circular>' +
                        '</div>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose:false,
                    fullscreen: false
                });
            else $mdDialog.cancel();

            //doSomething()
        });

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function() {
  'use strict';

  angular
    .module('app.login')
    .factory('AuthenticationService', AuthenticationService)
    .factory('Base64', Base64);

  /** @ngInject */
  function AuthenticationService(Base64, $http, $cookies, $rootScope, $location, $q, Notification) {
    var service = {};

    //controllo se sono presenti delle credenziali salvate
    service.checkCredentials = function() {
      var user = $cookies.getObject('user');
      if (angular.isUndefined(user)) {
        service.ClearCredentials();
        return false;
      } else if (user['currentUser']['remember'] == false) {
        service.ClearCredentials();
        return false;
      } else {
        $rootScope.globals = user;

        var data = {
          'data[User][username]': user.currentUser.username,
          'data[User][password]': user.currentUser.password,
          'data[User][id_comune]': $rootScope.id_comune
        };

        var promise = $http({
          method: 'POST',
          url: $rootScope.serverBasePath + 'users/checkLogin',
          data: $.param(data),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function successCallback(response) {

          if (response.data.success) {
            $http.defaults.headers.common['Authorization'] = 'Basic ' + $rootScope.globals['currentUser']['authdata'];
          } else {
            service.ClearCredentials();
            $location.path('/login');
          }

        });


      }
    }


    //login
    service.Login = function(username, password, callback) {
      var data = {
        'data[User][username]': username,
        'data[User][password]': password,
        'data[User][id_comune]': $rootScope.id_comune
      };
      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'users/login',
        data: $.param(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        // console.log('ciao');
        callback(response.data);
      });
      $rootScope.loadingTracker.addPromise(promise);
      return;

    };


    //imposta le credenziali per l'header, globali e se selezionato dall'utene le alva anche in memoria
    service.SetCredentials = function(loginData, username, password, rememberMe) {

      var authdata = Base64.encode(username + ':' + password);

      $rootScope.globals = {
        currentUser: {
          id: loginData.User.id,
          username: username,
          password: password,
          codAna: loginData['User']['cod_ana'],
          role: loginData['User']['role'],
          comune: loginData['User']['comune'],
          nome: loginData['User']['name'],
          cellulare: loginData['User']['cellulare'],
          email: loginData['User']['email'],
          remember: rememberMe,
          authdata: authdata,
          id_comune: $rootScope.id_comune
        }
      };

      var today = new Date();
      var expiresValue = new Date();

      expiresValue.setFullYear(today.getFullYear() + 1);

      $cookies.putObject('user', $rootScope.globals, {
        'expires': expiresValue
      });

      $http.defaults.headers.common['Authorization'] = 'Basic ' + authdata;

    };

    service.changePassword = function(psw, callback) {
      var data = {
        'user_id': $rootScope.globals.currentUser.id,
        'psw': psw,
        'id_comune': $rootScope.id_comune
      };


      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'users/changePassword',
        data: $.param(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {

        if (response.data.success) {
          $rootScope.globals.currentUser.password = response.data.data;
          $cookies.putObject('user', $rootScope.globals);
          callback(response.data);
        } else {
          callback(null);
        }

      });


      return;
    }

    service.SaveAccess = function(loginData, username) {
      var data = {
        'username': username,
        'codAna': loginData['User']['cod_ana'],
        'comune': loginData['User']['comune'],
        'id_comune': $rootScope.id_comune
      };
      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'users/saveAccess',
        data: $.param(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {

      });
      $rootScope.loadingTracker.addPromise(promise);
      return;
    }


    //cancella le credenziali salvate
    service.ClearCredentials = function() {
      $rootScope.globals = null;
      $cookies.remove('user');
      $http.defaults.headers.common.Authorization = 'Basic ';
    };


    //logout
    service.Logout = function() {

      var promise = $http({
        method: 'POST',

        url: $rootScope.serverBasePath + 'users/logout',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {
        if (response.data.success) {
          service.ClearCredentials();
          $state.go('app.login');
        }

      });

      $rootScope.loadingTracker.addPromise(promise);
      return;

    };

    service.goToLogin = function() {
      service.ClearCredentials();
      $state.go('app.login');
    };

    //prendo l'anno da mostrare nella schermata dati anno
    service.GetCurrentYear = function() {
      var data = {
        'id_comune': $rootScope.id_comune
      };
      var dfd = $q.defer();
      var promise = $http({
        method: 'POST',
        url: $rootScope.serverBasePath + 'users/getCurrentYear',
        data: $.param(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function successCallback(response) {

        if (response.data.success) {
          dfd.resolve(response.data.data);
        } else {
          Notification.warning({
            title: 'ATTENZIONE',
            message: "Impossibile trovare l'anno corrente",
            positionY: 'top'
          });
          dfd.resolve();
        }
      });

      $rootScope.loadingTracker.addPromise(promise);
      return dfd.promise;

    };

    return service;

  }

  function Base64() {

    var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

    return {
      encode: function(input) {
        var output = "";
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;

        do {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);

          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;

          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }

          output = output +
            keyStr.charAt(enc1) +
            keyStr.charAt(enc2) +
            keyStr.charAt(enc3) +
            keyStr.charAt(enc4);
          chr1 = chr2 = chr3 = "";
          enc1 = enc2 = enc3 = enc4 = "";
        } while (i < input.length);

        return output;
      },

      decode: function(input) {
        var output = "";
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;


        var base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) {
          window.alert("There were invalid base64 characters in the input text.\n" +
            "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
            "Expect errors in decoding.");
        }
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        do {
          enc1 = keyStr.indexOf(input.charAt(i++));
          enc2 = keyStr.indexOf(input.charAt(i++));
          enc3 = keyStr.indexOf(input.charAt(i++));
          enc4 = keyStr.indexOf(input.charAt(i++));

          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;

          output = output + String.fromCharCode(chr1);

          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }

          chr1 = chr2 = chr3 = "";
          enc1 = enc2 = enc3 = enc4 = "";

        } while (i < input.length);

        return output;
      }
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $location, AuthenticationService, Notification, $rootScope, $cookies, $state) {
        var vm = this;
        $scope.rememberMe = true;

        if (AuthenticationService.checkCredentials()) {
            if ($rootScope.globals.currentUser.role == 0) {
                $state.go('app.settings');
            } else {
                $state.go('app.infoComune');
            }

        }

        $scope.customStyleWindows = function() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            var trident = ua.indexOf('Trident/');
            var edge = ua.indexOf('Edge/');

            if (msie > 0 || trident > 0 || edge > 0) {

                var myStyle = {};
                return myStyle;
            } else {
                var myStyle = {
                    "display": "flex"
                };
                return myStyle;
            }
        }

        $scope.login = function() {
            AuthenticationService.ClearCredentials();
            //$scope.dataLoading = true; non so cosa sia

            AuthenticationService.Login($scope.username.toUpperCase(), $scope.password, function(response) {
                if (response.success) {

                    AuthenticationService.SetCredentials(response.data, $scope.username.toUpperCase(), $scope.password, $scope.rememberMe);
                    AuthenticationService.SaveAccess(response.data, $scope.username.toUpperCase());

                    if (response.data['User']['role'] == 0) {
                        $state.go('app.settings');
                    } else {
                        $state.go('app.infoComune');
                    }

                } else {
                    Notification.warning({
                        title: 'ATTENZIONE!',
                        message: response.message,
                        positionY: 'top'
                    });
                }
            });
        };

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.forgot-password': {
                    templateUrl: 'app/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

/*         // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        }); */
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($http,$scope, $location, Notification, $rootScope, $cookies, $state)
    {
        var vm = this;
        $scope.showError = false;
        $scope.showForm = true;

        // Methods

        $scope.resetPassword = function(){
            $scope.param = {'username' : $scope.username.toUpperCase(), 'id_comune': $rootScope.id_comune};
            //console.log($scope.param);
             var promise = $http({
                method: 'POST',
                url: $rootScope.serverBasePath + 'users/resetPassword',
                data: $.param($scope.param),
                // set the headers so angular passing info as form data (not request payload)
                headers : { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function(response) {

                    if(response.data.success){
                        $scope.shoewError = false;
                        $scope.showForm = false;
                    } else {
                        $scope.showError = true;
                        $scope.showForm = true;
                    }
                });
            $rootScope.loadingTracker.addPromise(promise);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $mdDateLocaleProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        $mdDateLocaleProvider.formatDate = function(date) {
            return moment(date).format('DD/MM/YYYY');
        };

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        //var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function() {

  'use strict';
  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming, $rootScope, $location, AuthenticationService, $cookies) {
    var vm = this;
    vm.themes = fuseTheming.themes;

    var location = document.location + "";
    //console.log(location);
    if (location.search('localhost') > -1) {
      //console.log('localhost');
      $rootScope.id_comune = 1;
      $rootScope.serverBasePath = "https://portale-imu.cadonegheservizi.it/server/";

      if (location.search('cadoneghe') > -1) {
        //console.log('Cadoneghe');
        $rootScope.id_comune = 1;
        $rootScope.serverBasePath = "http://localhost/portale-imu-server/";
      }
      if (location.search('piombinodese') > -1) {
        //console.log('Piombino');
        $rootScope.id_comune = 2;
        $rootScope.serverBasePath = "http://localhost/portale-imu-server/";
      }

    } else {
      if (location.search('cadonegheservizi') > -1) {
        $rootScope.id_comune = 1;
        $rootScope.serverBasePath = "https://portale-imu.cadonegheservizi.it/server/";
      }
      if (location.search('comunepiombinodese') > -1) {
        $rootScope.id_comune = 2;
        $rootScope.serverBasePath = "https://portale-imu.servizi-comunepiombinodese.it/server/";
      }
      if (location.search('campodarsego') > -1) {
        $rootScope.id_comune = 3;
        $rootScope.serverBasePath = "https://portale-imu.servizicomunecampodarsego.it/server/";
      }
      if (location.search('trebaseleghe') > -1) {
        $rootScope.id_comune = 4;
        $rootScope.serverBasePath = "https://portale-imu.servizi-comunetrebaseleghe.it/server/";
      }
    }

    // $rootScope.id_comune = 1;
    // $rootScope.serverBasePath = "https://portale-imu.cadonegheservizi.it/server/";


    $rootScope.checkMybrowser = function() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      var trident = ua.indexOf('Trident/');
      var edge = ua.indexOf('Edge/');

      if (msie > 0 || trident > 0 || edge > 0) {
        //console.log("Microsoft");
        var myStyle = {};
        return myStyle;
      } else {
        var myStyle = {
          "display": "flex"
        };
        return myStyle;
      }
    }

    $rootScope.convertToFormData = function(item) {
      var form_data = new FormData();
      for (var key in item) {
        form_data.append(key, item[key]);
      }
      return form_data;
    }

    //restituisce il link per l'immagine del comune
    $rootScope.getLogo = function() {
      if (document.location.hostname != "localhost") {
        return $rootScope.serverBasePath + "webroot/resources/logo_comuni_login/" + $rootScope.id_comune + ".jpg";
      } else {
        return $rootScope.serverBasePath + "resources/logo_comuni_login/" + $rootScope.id_comune + ".jpg";
      }

    }


    //controlle se il mio profilo è presente nei coockies
    if (angular.isUndefined($rootScope.globals)) {
      AuthenticationService.checkCredentials();
    }

    $rootScope.$on('$stateChangeStart',
      function(event, toState, toParams, fromState, fromParams) {
        if (($location.path() != '/login') && (angular.isUndefined($rootScope.globals) || $rootScope.globals == null)) {
          if (angular.isUndefined($cookies.getObject('user'))) {
            AuthenticationService.ClearCredentials();
            $location.path('/login');
          }
        }
      });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.login')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/login');
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\" \nstyle=\"position: relative;background-image: url(\'/assets/images/background.png\')\"><div id=\"forgot-password-form\" \nclass=\"md-whiteframe-8dp\" style=\"z-index: 1\"><h1>Recupero password</h1><div class=\"logo\"><img class=\"logo-image\" \nsrc=\"assets/images/mybiz.png\"></div><form name=\"forgotPasswordForm\" ng-submit=\"resetPassword()\" novalidate \nng-show=\"showForm\"><md-input-container class=\"md-block\" md-no-float><input type=\"username\" name=\"username\" \nng-model=\"username\" placeholder=\"Username/Codice fiscale\" required></md-input-container><div ng-show=\"showError\">\nUtente non registrato.</div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid\">SEND RESET LINK</md-button></form><div \nng-show=\"!showForm\">Password resettata con successo. A breve arriverà un sms con la nuova password.</div><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\">Torna al login</a></div>\n</div></div></div>");
$templateCache.put("app/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\" style=\"position: relative;background-image: url(\'/assets/images/background.png\')\"><div \nid=\"login-form\" class=\"md-whiteframe-8dp\" style=\"z-index: 1\"><h1>BENVENUTO</h1><div class=\"logo\" \nng-style=\"customStyleWindows()\"><img class=\"logo-image\" style=\"margin: auto\" ng-src=\"{{getLogo()}}\"></div><form \nname=\"loginForm\" ng-submit=\"login()\" role=\"form\"><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"username\" id=\"username\" ng-model=\"username\" placeholder=\"Username\" class=\"form-control\" required><div \nng-messages=\"loginForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIl nome utente è obbligatorio</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-bottom: 0\"><input type=\"password\" name=\"password\" id=\"password\" ng-model=\"password\" \nplaceholder=\"Password\" class=\"form-control\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>La password è obbligatoria</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nng-model=\"rememberMe\" aria-label=\"Checkbox 1\">Ricordami</md-checkbox><a ui-sref=\"app.forgot-password\" \nclass=\"forgot-password md-accent-color\">Password dimenticata?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nstyle=\"background-color: #096dd9\">ACCEDI</md-button></form><div class=\"register\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\"><span class=\"text\">Non hai un account?</span> <a class=\"forgot-password md-accent-color\" \nui-sref=\"app.register\">Registrati</a></div></div></div></div>");
$templateCache.put("app/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\" style=\"position: relative;background-image: url(\'/assets/images/background.png\')\"><div \nid=\"register-form\" class=\"md-whiteframe-8dp\" style=\"z-index: 1\"><h1>NUOVO ACCOUNT</h1><div class=\"logo\"><img \nclass=\"logo-image\" src=\"assets/images/mybiz.png\"></div><form name=\"registerForm\" ng-submit=\"createUser()\" novalidate \nng-show=\"showForm\"><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"tax-code\" id=\"tax-code\" \nng-model=\"codiceFiscale\" placeholder=\"Codice Fiscale/P. IVA\" required><div ng-messages=\"registerForm.tax-code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Il codice fiscale è obbligatorio</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"cellNumber\" ng-model=\"numeroTelefono\" \nplaceholder=\"Cellulare\" required><div ng-messages=\"registerForm.cellNumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Il numero di cellulare è obbligatorio</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"email\" placeholder=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Inserire un indirizzo e-mail valido</span></div><div ng-message=\"required\"><span>\nL\'indirizzo email è obbligatorio</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><md-input-container class=\"md-block\" ng-show=\"uploader.queue.length==0\"><span>Allega carta di identità\n</span> <input id=\"uploadFile\" type=\"file\" nv-file-select uploader=\"uploader\" \naccept=\"image/jpeg,image/gif,image/png,application/pdf\" style=\"margin-top: 2px\"></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"retroUploader.queue.length==0\"><span>\nRetro carta di identità (facoltativo)</span> <input id=\"uploadRetro\" type=\"file\" \naccept=\"image/jpeg,image/gif,image/png,application/pdf\" nv-file-select uploader=\"retroUploader\"></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><div layout=\"row\" ng-show=\"uploader.queue.length>0\"><h3>\n{{ uploader.queue[0].file.name }} - {{ uploader.queue[0].file.size/1024/1024|number:2 }} MB</h3><md-button \nng-click=\"deleteItem()\" style=\"min-width: 1%\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-trash material-icons md-default-theme\" aria-hidden=\"true\"></md-icon>\n</md-button></div></md-input-container><md-input-container class=\"md-block\" md-no-float><div layout=\"row\" \nng-show=\"retroUploader.queue.length>0\"><h3>\n{{ retroUploader.queue[0].file.name }} - {{ retroUploader.queue[0].file.size/1024/1024|number:2 }} MB</h3><md-button \nng-click=\"deleteRetroItem()\" style=\"min-width: 1%\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-trash material-icons md-default-theme\" aria-hidden=\"true\"></md-icon>\n</md-button></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"INVIA RICHIESTA\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine || uploader.queue.length==0\">\nINVIA RICHIESTA</md-button></md-input-container></form><div ng-show=\"!showForm\">\nRichiesta inviata con successo. Sarà presa in carico il prima possibile e riceverà un messaggio con le credenziali.\n</div><div class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\">\nHai già un account?</span> <a class=\"link\" ui-sref=\"app.login\">Log in</a></div></div></div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/main/accessi/accessi.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header custom-color\" layout=\"row\" \nlayout-align=\"space-between\" style=\"height: auto !important; min-height: 0px !important\"><div layout=\"column\" \nlayout-align=\"center start\" style=\"display: inline-block;text-align:center\"><div class=\"title\" style=\"float: left\">\nRicerca per data</div></div></div><div class=\"content\"><div layout=\"row\" style=\"margin-bottom: 50px; margin-left:25px\">\n<div flex-gt-xs><h4>Data inizio</h4><md-datepicker ng-model=\"vm.dataInizio\" md-placeholder=\"Enter date\">\n</md-datepicker></div><div flex-gt-xs><h4>Data fine</h4><md-datepicker ng-model=\"vm.dataFine\" \nmd-placeholder=\"Enter date\"></md-datepicker></div></div><md-button class=\"md-raised md-primary\" \nstyle=\"margin-bottom:15px\" ng-click=\"searcAccess()\">Cerca</md-button><div class=\"white-bg md-whiteframe-4dp\"><table \ndatatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\" \nstyle=\"width: 100% !important\"></table></div></div></div>");
$templateCache.put("app/main/anagrafiche/anagrafiche.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header custom-color\" layout=\"row\" \nlayout-align=\"space-between\" style=\"height: auto !important; min-height: 0px !important\"><div layout=\"column\" \nlayout-align=\"center start\" style=\"display: inline-block;text-align:center\"><div class=\"title\" style=\"float: left\">\nAnagrafiche</div></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table datatable=\"\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\" \nstyle=\"width: 100% !important\"></table></div></div></div>");
$templateCache.put("app/main/anagrafiche/details-dialog.html","<md-dialog aria-label=\"Staff\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{selectedUser.anagrafica.cognome}} {{selectedUser.anagrafica.nome}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon class=\"icon-close-circle-outline icon-size\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"simple-table-container\"><table class=\"simple\" ms-responsive-table><tr><th>Sesso</th><td>\n{{selectedUser.anagrafica.sesso}}</td></tr><tr><th>Data di nascita</th><td>{{selectedUser.anagrafica.data_nascita}}\n</td></tr><tr><th>Luogo di nascita</th><td>\n{{selectedUser.anagrafica.luogo_nascita}} {{selectedUser.anagrafica.prov_nascita}}</td></tr><tr><th>Indirizzo</th><td>\n{{selectedUser.anagrafica.indirizzo}}, {{selectedUser.anagrafica.civico}} {{selectedUser.anagrafica.barrato}} - {{selectedUser.anagrafica.cap}}\n</td></tr><tr><th>Comune</th><td>{{selectedUser.anagrafica.comune}}, {{selectedUser.anagrafica.provincia}}</td></tr>\n<tr><th>Mail</th><td><input style=\"border: solid black 1px; border-radius:5px;padding: 4px\" ng-model=\"email\"></td></tr>\n<tr><th>Telefono</th><td><input style=\"border: solid black 1px; border-radius:5px;padding: 4px\" ng-model=\"phone\" \nng-maxlength=\"13\"></td></tr></table><div style=\"width: 100%; display: flex; margin-top: 10px\"><button \nstyle=\"margin:auto;    \n        width: 35%;\n        color: white;\n        padding:5px;\n        font-size: 20px;\n        font-weight: 500;\n        background-color: red;\n        border-radius: 50px\" \nng-click=\"save(email,phone)\">Save</button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/datiAttuali/datiAttuali.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header custom-color customheader\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"titleHeader\">\nDati Anno {{globals.currentYear}}&nbsp;&nbsp;-&nbsp;&nbsp;Data elaborazione: {{data_elaborazione}}</div></div></div>\n<div class=\"content\"><div class=\"md-title mb-32\">Azioni rapide</div><div flex><md-card layout=\"row\" flex \nng-style=\"customStyleWindows()\"><md-card-content layout=\"row\" flex><button class=\"btn btn-warning\" \nng-click=\"printF24(\'A\')\" style=\"margin: auto;display:flex\" ng-style=\"customStyleWindows()\"><span \nstyle=\"font-weight: bold;margin: auto;color: grey\">Stampa acconto F24</span><md-icon md-font-icon=\"icon-printer\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-printer material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"bottom\">Stampa acconto</md-tooltip></button> <button class=\"btn btn-warning\" \nng-click=\"printF24(\'S\')\" style=\"margin: auto;display:flex\" ng-style=\"customStyleWindows()\"><span \nstyle=\"font-weight: bold;margin: auto;color: grey\">Stampa saldo F24</span><md-icon md-font-icon=\"icon-printer\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-printer material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"bottom\">Stampa saldo</md-tooltip></button></md-card-content></md-card></div><br>\n<div class=\"md-title mb-32\">Voci di imposta da versare</div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-card \nng-if=\"userTotals[0] || userTotals[1]\" ng-style=\"customStyleWindows()\"><md-card-content \nstyle=\"height: 100%;display: flex\"><md-tabs md-dynamic-height style=\"width: 100%\"><md-tab label=\"IMU\" \nng-if=\"checkIMUTASI(0)\"><md-content class=\"md-padding\"><table class=\"simple\" style=\"margin:auto\" ng-if=\"userTotals\">\n<tbody><tr><td style=\"font-weight: bold\">Totale dovuto annuo</td><td><span>{{getDataFromTotals(0) | number:2 }}€</span>\n<br></td></tr><tr><td style=\"font-weight: bold\">Totale versato</td><td><span>{{getDataFromTotals(1) | number:2 }}€\n</span><br></td></tr><tr><td style=\"font-weight: bold\">Differenza da versare</td><td><span>\n{{getDataFromTotals(2) | number:2 }}€</span><br></td></tr></tbody></table></md-content></md-tab><md-tab label=\"TASI\" \nng-if=\"checkIMUTASI(1)\"><md-content class=\"md-padding\"><table class=\"simple\" style=\"margin:auto\" ng-if=\"userTotals\">\n<tbody><tr><td style=\"font-weight: bold\">Totale dovuto annuo</td><td><span>{{getDataFromTotals(3) | number:2 }}€</span>\n<br></td></tr><tr><td style=\"font-weight: bold\">Totale versato</td><td><span>{{getDataFromTotals(4) | number:2 }}€\n</span><br></td></tr><tr><td style=\"font-weight: bold\">Differenza da versare</td><td><span>\n{{getDataFromTotals(5) | number:2 }}€</span><br></td></tr></tbody></table></md-content></md-tab></md-tabs>\n</md-card-content></md-card><md-card flex><md-card-content><button class=\"btn btn-warning\" ng-click=\"showInfoF24()\" \nstyle=\"float:right;display: flex; margin-left: 10px\"><md-icon md-font-icon=\"icon-information-outline\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-information-outline material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"bottom\">Legenda</md-tooltip></button><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tributo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Acc saldo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">EL</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Codtr</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ente</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Acconto</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Saldo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NR</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Detrazione</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Importo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Info</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in ::vm.totali\"><td>{{item.totali.tributo}} - {{item.totali.tributo == 0? \'IMU\':\'TASI\'}}</td><td>\n{{ item.totali.acc_saldo }}</td><td>{{ item.totali.el }}</td><td>{{ item.totali.codtr }}</td><td>{{ item.totali.ente }}\n</td><td>{{ item.totali.acconto }}</td><td>{{ item.totali.saldo }}</td><td>{{ item.totali.nr }}</td><td>\n{{ item.totali.detrazione }}</td><td>{{ item.totali.importo | number : 2 }}</td><td>{{ item.totali.info }}</td></tr>\n</tbody></table></md-card-content></md-card></div><br><div class=\"md-title mb-32\">Elenco immobili con totali annui\n</div><md-tabs md-dynamic-height><md-tab label=\"IMU\"><md-content class=\"md-padding\"><div \nclass=\"white-bg md-whiteframe-4dp\"><button class=\"btn btn-warning\" ng-click=\"showInfo()\" \nstyle=\"float:right;display: flex; margin-left: 10px\"><md-icon md-font-icon=\"icon-information-outline\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-information-outline material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"bottom\">Legenda</md-tooltip></button> <button \nclass=\"btn btn-warning\" ng-click=\"printImu()\" style=\"float:right;display: flex\" ng-if=\"vm.immobiliImu.length >0\"><span \nstyle=\"margin:auto;font-weight: bold;color: grey\">Stampa elenco immobili</span><md-icon md-font-icon=\"icon-printer\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-printer material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"bottom\">Stampa</md-tooltip></button><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Dati Catastali</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Indirizzo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">% Quota</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mesi</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rendita catastale</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Valore imponibile</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Detr ab.pr</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ab.Rd.Es.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Comune Aliq-Imposta</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Stato Aliq-Imposta</span></div></th><th class=\"secondary-text\" ng-if=\"booleanNotes\"><div \nclass=\"table-header\"><span class=\"column-title\">Note</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in ::vm.immobiliImu\"><td>\n{{item.immobili.foglio}}/{{item.immobili.mappale}}/{{item.immobili.subalterno}}-{{item.immobili.cat}}</td><td>\n{{ item.immobili.indirizzo }} {{ item.immobili.civico }}</td><td>{{ item.immobili.perc }}</td><td>\n{{ item.immobili.mesi }}</td><td>{{ item.immobili.rendita }}</td><td>{{ item.immobili.valore }}</td><td>\n{{ item.immobili.detrazione }}</td><td>{{ item.immobili.abpr }}-{{ item.immobili.rid }}-{{ item.immobili.ese }}</td>\n<td>{{ item.immobili.al_comune }}-{{ item.immobili.imp_comune }}</td><td>\n{{ item.immobili.al_stato }}-{{ item.immobili.imu_stato }}</td><td ng-if=\"booleanNotes\">\n{{ item.immobili.note_immobile }}</td></tr></tbody></table></div></md-content></md-tab><md-tab label=\"TASI\"><md-content\n class=\"md-padding\"><div class=\"white-bg md-whiteframe-4dp\"><button class=\"btn btn-warning\" ng-click=\"showInfo()\" \nstyle=\"float:right;display: flex; margin-left: 10px\"><md-icon md-font-icon=\"icon-information-outline\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-information-outline material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"bottom\">Legenda</md-tooltip></button> <button \nclass=\"btn btn-warning\" ng-click=\"printTasi()\" style=\"float:right; display: flex\" ng-if=\"vm.immobiliTasi.length >0\">\n<span style=\"margin:auto;font-weight: bold;color: grey\">Stampa elenco immobili</span><md-icon \nmd-font-icon=\"icon-printer\" style=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-printer material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"bottom\">Stampa</md-tooltip></button><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Dati Catastali</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Indirizzo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">% Quota</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mesi</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rendita catastale</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Valore imponibile</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Detr ab.pr</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ab.Rd.Es.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Comune Aliq-Imposta</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Stato Aliq-Imposta</span></div></th><th class=\"secondary-text\" ng-if=\"booleanNotes\"><div \nclass=\"table-header\"><span class=\"column-title\">Note</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in ::vm.immobiliTasi\"><td>\n{{item.immobili.foglio}}/{{item.immobili.mappale}}/{{item.immobili.subalterno}}-{{item.immobili.cat}}</td><td>\n{{ item.immobili.indirizzo }} {{ item.immobili.civico }}</td><td>{{ item.immobili.perc }}</td><td>\n{{ item.immobili.mesi }}</td><td>{{ item.immobili.rendita }}</td><td>{{ item.immobili.valore }}</td><td>\n{{ item.immobili.detrazione }}</td><td>{{ item.immobili.abpr }}-{{ item.immobili.rid }}-{{ item.immobili.ese }}</td>\n<td>{{ item.immobili.al_comune }}-{{ item.immobili.imp_comune }}</td><td>\n{{ item.immobili.al_stato }}-{{ item.immobili.imu_stato }}</td><td ng-if=\"booleanNotes\">\n{{ item.immobili.note_immobile }}</td></tr></tbody></table></div></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/cambioPassword/cambioPassword.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" \nstyle=\"display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;-ms-flex-direction: column;flex-direction: column\">\n<div class=\"header custom-color\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"titleHeader\">CAMBIO PASSWORD</div></div></div><div \nstyle=\"margin-top: 5%;width: 100%; height: 100%; display:-webkit-box; display:-ms-flexbox; display:flex\"><md-card \nstyle=\"margin: auto\"><md-card-title><md-card-title-text><span class=\"md-headline\" \nstyle=\"font-size: xx-large;text-align:center;margin-bottom:20px\">CAMBIO PASSWORD</span></md-card-title-text>\n</md-card-title><md-card-content><div layout=\"column\" layout-align=\"center start\"><span \nstyle=\"margin: auto;width: 80%;margin-bottom:50px;font-size: initial;text-align:center\">\nLa password non deve contenere simboli e deve essere lunga almeno 8 caratteri</span><md-input-container \nstyle=\"margin: auto;margin-bottom:15px\"><label style=\"font-size: xx-large\">Nuova password</label><input \nstyle=\"font-size: xx-large;text-align:center\" ng-change=\"checkPswA()\" ng-model=\"password\" type=\"password\">\n</md-input-container><md-input-container style=\"margin: auto;margin-bottom:20px\"><label style=\"font-size: xx-large\">\nRipeti password</label><input style=\"font-size: xx-large;text-align:center\" ng-change=\"checkPswB()\" \nng-model=\"_password\" type=\"password\"></md-input-container><md-button ng-click=\"changePassword()\" \nclass=\"md-raised md-accent\" aria-label=\"change password\" \nng-disabled=\"password != _password || password ==\'\'  || password.length < 8 || check\" \nstyle=\"background-color: #096dd9;margin: auto\">SALVA</md-button></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/datiStorici/datiStorici.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header custom-color\" layout=\"row\" \nlayout-align=\"start\"><div class=\"titleHeader\" style=\"font-size: 28px;margin-top: 5px;display:flex\"><span \nstyle=\"margin: auto\">Anno da visualizzare:&nbsp;&nbsp;</span></div><md-input-container class=\"custom-select\" \nstyle=\"margin: auto 0\"><label style=\"color:white\">Anno</label><md-select ng-model=\"selectedYear\" \nstyle=\"font-size: 28px; color: white\" ng-change=\"getDatiStorici()\"><md-option ng-repeat=\"year in years\" \nng-value=\"year.pagamenti_utente.anno\">{{year.pagamenti_utente.anno}}</md-option></md-select></md-input-container></div>\n<div class=\"content\"><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"visible\"><md-card \nng-if=\"userTotals[0] || userTotals[1]\" ng-style=\"customStyleWindows()\" style=\"min-width: 20%\"><md-card-title \nstyle=\"max-height: 60%\"><md-card-title-text><span class=\"md-headline\">Voci di imposta da versare</span>\n</md-card-title-text></md-card-title><md-card-content style=\"height: 100%;display: flex\"><md-tabs md-dynamic-height \nstyle=\"width: 100%\"><md-tab label=\"IMU\" ng-if=\"checkIMUTASI(0)\"><md-content class=\"md-padding\"><table class=\"simple\" \nstyle=\"margin:auto\" ng-if=\"userTotals\"><tbody><tr><td style=\"font-weight: bold\">Totale dovuto annuo</td><td><span>\n{{getDataFromTotals(0) | number:2 }}€</span><br></td></tr><tr><td style=\"font-weight: bold\">Totale versato</td><td>\n<span>{{getDataFromTotals(1) | number:2 }}€</span><br></td></tr><tr><td style=\"font-weight: bold\">Differenza da versare\n</td><td><span>{{getDataFromTotals(2) | number:2 }}€</span><br></td></tr></tbody></table></md-content></md-tab><md-tab \nlabel=\"TASI\" ng-if=\"checkIMUTASI(1)\"><md-content class=\"md-padding\"><table class=\"simple\" style=\"margin:auto\" \nng-if=\"userTotals\"><tbody><tr><td style=\"font-weight: bold\">Totale dovuto annuo</td><td><span>\n{{getDataFromTotals(3) | number:2 }}€</span><br></td></tr><tr><td style=\"font-weight: bold\">Totale versato</td><td>\n<span>{{getDataFromTotals(4) | number:2 }}€</span><br></td></tr><tr><td style=\"font-weight: bold\">Differenza da versare\n</td><td><span>{{getDataFromTotals(5) | number:2 }}€</span><br></td></tr></tbody></table></md-content></md-tab>\n</md-tabs></md-card-content></md-card><md-card ng-style=\"customStyleWindows()\" style=\"min-width: 78%\"><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Elenco immobili con totali annui</span></md-card-title-text>\n</md-card-title><md-card-content><md-tabs md-dynamic-height><md-tab label=\"IMU\"><md-content class=\"md-padding\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"box-shadow: none\"><button class=\"btn btn-warning\" ng-click=\"showInfo()\" \nstyle=\"float:right;display: flex; margin-left: 10px\"><md-icon md-font-icon=\"icon-information-outline\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-information-outline material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"bottom\">Legenda</md-tooltip></button> <button \nclass=\"btn btn-warning\" ng-click=\"printImu()\" style=\"float:right;display: flex\" ng-if=\"immobiliImu.length >0\"><span \nstyle=\"margin:auto;font-weight: bold;color: grey\">Stampa elenco immobili</span><md-icon md-font-icon=\"icon-printer\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-printer material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"bottom\">Stampa</md-tooltip></button><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Dati Catastali</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Indirizzo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">% Quota</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mesi</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rendita catastale</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Valore imponibile</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Detr ab.pr</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ab.Rd.Es.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Comune Aliq-Imposta</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Stato Aliq-Imposta</span></div></th><th class=\"secondary-text\" ng-if=\"booleanNotes\"><div \nclass=\"table-header\"><span class=\"column-title\">Note</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in immobiliImu\"><td>\n{{item.immobili.foglio}}/{{item.immobili.mappale}}/{{item.immobili.subalterno}}-{{item.immobili.cat}}</td><td>\n{{ item.immobili.indirizzo }} {{ item.immobili.civico }}</td><td>{{ item.immobili.perc }}</td><td>\n{{ item.immobili.mesi }}</td><td>{{ item.immobili.rendita }}</td><td>{{ item.immobili.valore }}</td><td>\n{{ item.immobili.detrazione }}</td><td>{{ item.immobili.abpr }}-{{ item.immobili.rid }}-{{ item.immobili.ese }}</td>\n<td>{{ item.immobili.al_comune }}-{{ item.immobili.imp_comune }}</td><td>\n{{ item.immobili.al_stato }}-{{ item.immobili.imu_stato }}</td><td ng-if=\"booleanNotes\">\n{{ item.immobili.note_immobile }}</td></tr></tbody></table></div></md-content></md-tab><md-tab label=\"TASI\"><md-content\n class=\"md-padding\"><div class=\"white-bg md-whiteframe-4dp\" style=\"box-shadow: none\"><button class=\"btn btn-warning\" \nng-click=\"showInfo()\" style=\"float:right;display: flex; margin-left: 10px\"><md-icon \nmd-font-icon=\"icon-information-outline\" style=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-information-outline material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"bottom\">Legenda</md-tooltip></button> <button \nclass=\"btn btn-warning\" ng-click=\"printTasi()\" style=\"float:right; display: flex\" ng-if=\"immobiliTasi.length >0\"><span \nstyle=\"margin:auto;font-weight: bold;color: grey\">Stampa elenco immobili</span><md-icon md-font-icon=\"icon-printer\" \nstyle=\"margin:10px; float:right\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-printer material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"bottom\">Stampa</md-tooltip></button><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Dati Catastali</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Indirizzo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">% Quota</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mesi</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rendita catastale</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Valore imponibile</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Detr ab.pr</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ab.Rd.Es.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Comune Aliq-Imposta</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Stato Aliq-Imposta</span></div></th><th class=\"secondary-text\" ng-if=\"booleanNotes\"><div \nclass=\"table-header\"><span class=\"column-title\">Note</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in immobiliTasi\"><td>\n{{item.immobili.foglio}}/{{item.immobili.mappale}}/{{item.immobili.subalterno}}-{{item.immobili.cat}}</td><td>\n{{ item.immobili.indirizzo }} {{ item.immobili.civico }}</td><td>{{ item.immobili.perc }}</td><td>\n{{ item.immobili.mesi }}</td><td>{{ item.immobili.rendita }}</td><td>{{ item.immobili.valore }}</td><td>\n{{ item.immobili.detrazione }}</td><td>{{ item.immobili.abpr }}-{{ item.immobili.rid }}-{{ item.immobili.ese }}</td>\n<td>{{ item.immobili.al_comune }}-{{ item.immobili.imp_comune }}</td><td>\n{{ item.immobili.al_stato }}-{{ item.immobili.imu_stato }}</td><td ng-if=\"booleanNotes\">\n{{ item.immobili.note_immobile }}</td></tr></tbody></table></div></md-content></md-tab></md-tabs></md-card-content>\n</md-card></div><div layout=\"column\" flex ng-if=\"!visible\"><md-card ng-style=\"customStyleWindows()\"><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Per visualizzare i dati seleziona un anno dalla lista</span>\n</md-card-title-text></md-card-title></md-card></div></div></div>");
$templateCache.put("app/main/infoComune/infoComune.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header custom-color\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"titleHeader\">{{titolo}}<br>\n{{email}}{{cellulare}}</div></div></div><md-content class=\"md-padding\" flex><div layout=\"column\" layout-gt-sm=\"row\" \nflex><md-card flex><md-card-title><md-card-title-text><span class=\"md-headline\">Contatti</span></md-card-title-text>\n</md-card-title><md-card-content><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h3>Indirizzo</h3><p>\n{{vm.contatti.indirizzo}}, {{vm.contatti.citta}} ({{vm.contatti.provincia}})</p><br><h3>Telefono</h3><p hide \nshow-gt-xs>{{vm.contatti.telefono}}</p><a hide show-xs href=\"tel:{{vm.contatti.telefono}}\">{{vm.contatti.telefono}}\n<md-icon md-font-icon=\"icon-phone\"></md-icon></a><br><h3>Fax</h3><p>{{vm.contatti.fax}}</p><br><h3>Mail</h3><a \nng-href=\"mailto: {{vm.contatti.email}}\" target=\"_self\">{{vm.contatti.email}}</a><br><h3>Pec</h3><a \nng-href=\"mailto: {{vm.contatti.pec}}\" target=\"_self\">{{vm.contatti.pec}}</a></div></md-list-item></md-card-content>\n</md-card><md-card flex><md-card-title><md-card-title-text><span class=\"md-headline\">Orari</span></md-card-title-text>\n</md-card-title><md-card-content><table class=\"simple\" ms-responsive-table><thead><tr><th>Giorno</th><th>Ora</th></tr>\n</thead><tbody><tr ng-repeat=\"hours in vm.contatti.openinghours\" ng-if=\"hours != null\"><td>\n{{getLongDay(hours.day_week)}}</td><td><span ng-repeat=\"hour in hours.day_hours\">\n{{getHour(hour.start_hour)}} - {{getHour(hour.end_hour)}} </span><br></td></tr></tbody></table></md-card-content>\n</md-card><md-card flex ng-show=\"vm.documents.length>0\"><md-card-title><md-card-title-text><span class=\"md-headline\">\nCollegamenti</span></md-card-title-text></md-card-title><md-card-content style=\"min-height: 75%\"><div layout=\"row\"><a \ntarget=\"_blank\" href=\"https://sister.agenziaentrate.gov.it/CitizenVisure/index.jsp\"><md-button>\nConsultazioni rendite catastali</md-button></a></div></md-card-content></md-card></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-card flex><md-card-title ng-style=\"{\'max-height\': vm.documents.length>0 ? \'35%\' : \'\'}\">\n<md-card-title-text><span class=\"md-headline\">Note</span></md-card-title-text></md-card-title><md-card-content><p \nstyle=\"font-size: 1.25em\">{{vm.contatti.note}}</p></md-card-content></md-card><md-card flex \nng-show=\"vm.documents.length>0\"><md-card-title><md-card-title-text><span class=\"md-headline\">Testi Informativi</span>\n</md-card-title-text></md-card-title><md-card-content><div layout=\"row\" ng-repeat=\"document in vm.documents\"><a \nhref=\"{{document.path}}\" target=\"_blank\"><md-button>{{document.label}}</md-button></a></div></md-card-content>\n</md-card></div></md-content></div>");
$templateCache.put("app/main/settings/settings.html","<div ng-show=\"showLoading\" class=\"sfondoCaricamento\"><div class=\"loading-div\"><md-progress-circular md-diameter=\"96\" \nstyle=\"margin: auto\" class=\"md-accent md-hue-1\"></md-progress-circular><h1 style=\"color: white\">CARICAMENTO</h1></div>\n</div><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header custom-color\" \nlayout=\"row\" layout-align=\"space-between\" style=\"height: auto !important; min-height: 0px !important\"><div \nlayout=\"column\" layout-align=\"center start\" style=\"display: inline-block;text-align:center\"><div class=\"title\" \nstyle=\"float: left\">Impostazioni</div></div></div><div class=\"content\"><div class=\"form-wrapper md-whiteframe-1dp\">\n<form name=\"anagrafica\" class=\"md-inline-form\" novalidate><div class=\"form-title\">Contatti</div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" name=\"indirizzo\" ng-model=\"vm.contatti.indirizzo\" \nplaceholder=\"Indirizzo\"></md-input-container><md-input-container flex><input type=\"text\" name=\"citta\" \nng-model=\"vm.contatti.citta\" placeholder=\"Città\"></md-input-container><md-input-container><input type=\"text\" \nname=\"provincia\" ng-model=\"vm.contatti.provincia\" placeholder=\"Provincia\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" name=\"telefono\" \nng-model=\"vm.contatti.telefono\" placeholder=\"Telefono\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"email\" ng-model=\"vm.contatti.email\" placeholder=\"Email\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" name=\"fax\" ng-model=\"vm.contatti.fax\" \nplaceholder=\"Fax\"></md-input-container><md-input-container flex><input type=\"text\" name=\"pec\" \nng-model=\"vm.contatti.pec\" placeholder=\"Pec\"></md-input-container></div><div layout=\"row\"><md-input-container flex>\n<label>Note</label><textarea ng-model=\"vm.contatti.note\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container>\n</div><div style=\"text-align:right; margin-top:50px\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"anagrafica.$invalid\" ng-click=\"saveInfoComune()\">Salva</md-button></div></form></div><div \nclass=\"form-wrapper md-whiteframe-1dp\" style=\"margin-top:15px\" layout=\"row\"><div class=\"simple-table-container\" \nflex=\"70\"><div class=\"table-title\">Orari di apertura</div><table class=\"simple\" ms-responsive-table><thead><tr><th>\nGiorno</th><th>Ora</th><th style=\"width:2%\"></th></tr></thead><tbody><tr \nng-repeat=\"hours in vm.contatti.openinghours track by $index\" ng-if=\"hours != null\"><td>{{getLongDay(hours.day_week)}}\n</td><td><span ng-repeat=\"hour in hours.day_hours track by $index\">\n{{getHour(hour.start_hour)}} - {{getHour(hour.end_hour)}} </span><br></td><td style=\"text-align:right\" \ntitle=\"Elimina orario di apertura\"><i class=\"icon-delete md-secondary\" style=\"cursor:pointer\" \nng-click=\"deleteOpnhour(hours.day_week)\"></i></td></tr></tbody></table></div><div flex=\"5\"></div><div \nclass=\"simple-table-container\" flex=\"25\"><div class=\"table-title\">Aggiungi orario di apertura</div><md-input-container \nclass=\"settingsinput\" style=\"width:100%\"><label>Giorno</label><md-select ng-model=\"opnhour.day_week\"><md-option \nng-value=\"1\">Lunedì</md-option><md-option ng-value=\"2\">Martedì</md-option><md-option ng-value=\"3\">mercoledì</md-option>\n<md-option ng-value=\"4\">Giovedì</md-option><md-option ng-value=\"5\">Venerdì</md-option><md-option ng-value=\"6\">Sabato\n</md-option><md-option ng-value=\"0\">Domenica</md-option></md-select></md-input-container><md-input-container \nclass=\"dpsettingsinput\" style=\"width:100%;margin-top:10px\"><label>Inizio</label><input type=\"time\" \nng-model=\"opnhour.start_hour\"></md-input-container><md-input-container class=\"dpsettingsinput\" style=\"width:100%\">\n<label>Fine</label><input type=\"time\" ng-model=\"opnhour.end_hour\"></md-input-container><br><md-button \nclass=\"md-raised md-primary\" style=\"width:100%\" ng-click=\"addOpeninghour()\" ng-disabled=\"disopnhour()\">Aggiungi\n</md-button></div></div><div class=\"form-wrapper md-whiteframe-1dp\" style=\"margin-top:15px\" layout=\"row\"><div \nclass=\"simple-table-container\" flex=\"30\"><div class=\"table-title\">Caricamento Dati</div><md-input-container \nclass=\"settingsinput\" style=\"width:100%\"><label>Tipo di file</label><md-select ng-model=\"data\" ng-model=\"myValue\" \nng-change=\"clearQueueUpload()\" style=\"background: #02fd0294;border-radius: 10px\"><md-option ng-value=\"1\">\nTesti Informativi</md-option><md-option ng-value=\"2\">Immobili</md-option><md-option ng-value=\"3\">\nTotali F24 - cod. tributo</md-option><md-option ng-value=\"4\">Contribuenti</md-option><md-option ng-value=\"5\">Totali\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-show=\"data != 1\">\n<md-input-container class=\"md-block\" ng-show=\"dataUploader.queue.length==0\"><input id=\"uploadFile\" type=\"file\" \nnv-file-select uploader=\"dataUploader\"></md-input-container><div layout=\"row\" ng-show=\"dataUploader.queue.length>0\"><h3\n ng-if=\"!checkDimension()\">\n{{ dataUploader.queue[0].file.name }} - {{ dataUploader.queue[0].file.size/1024 | number: 2 }} KB</h3><h3 \nng-if=\"checkDimension()\">\n{{ dataUploader.queue[0].file.name }} - {{ dataUploader.queue[0].file.size/1024/1024 | number: 2 }} MB</h3><md-button \nng-click=\"deleteItem()\" style=\"min-width: 1%\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-trash material-icons md-default-theme\" aria-hidden=\"true\"></md-icon>\n</md-button></div></md-input-container><md-input-container class=\"md-block\" ng-show=\"data == 1\"><md-input-container \nclass=\"md-block\" ng-show=\"dataUploader.queue.length < 4\"><input type=\"file\" nv-file-select=\"\" uploader=\"dataUploader\" \nmultiple=\"multiple\"><br></md-input-container><p>Documenti in coda: {{ dataUploader.queue.length }}</p><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table \nng-show=\"dataUploader.queue.length>0\"><thead><tr><th>Nome</th><th>Dimensioni</th><th>Azioni</th></tr></thead><tbody><tr\n ng-repeat=\"item in dataUploader.queue track by $index\"><td>{{item.file.name}}</td><td>\n{{item.file.size/1024/1024|number:2}} MB</td><td><button ng-click=\"item.remove()\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"icon ng-scope ng-isolate-scope md-font icon-trash material-icons md-default-theme\" aria-hidden=\"true\"></md-icon>\n</button></td></tr></tbody></table></div><div><div><div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" \nng-style=\"{ \'width\': dataUploader.progress + \'%\' }\"></div></div></div></div></md-input-container><br><md-button \nclass=\"md-raised md-primary\" ng-click=\"uploadData()\" ng-disabled=\"dataUploader.queue.length < 1\">Carica</md-button>\n<md-button class=\"md-raised md-primary\" ng-click=\"clearQueueUpload()\" ng-disabled=\"dataUploader.queue.length < 1\">\nRimuovi tutti</md-button><md-button class=\"md-raised md-primary\" ng-click=\"popupMakeUsers()\">GENERA UTENTI</md-button>\n</div><div flex=\"5\"></div><div class=\"simple-table-container\" flex=\"30\"><div class=\"table-title\">Testi informativi\n</div><table class=\"simple\" ms-responsive-table><thead><tr><th>Titolo</th><th style=\"width:2%\"></th></tr></thead>\n<tbody><tr ng-repeat=\"(key, value) in vm.testiInformativi track by $index\"><td>{{value}}</td><td \nstyle=\"text-align:right\" title=\"Elimina testo\"><i class=\"icon-delete md-secondary\" style=\"cursor:pointer\" \nng-click=\"deleteFile(key)\"></i></td></tr></tbody></table><br><br></div><div flex=\"5\" style=\"position: relative\"><div \nstyle=\"height:100%;width: 1px;margin: auto;border-left: solid #dadada 1px\"></div></div><div \nclass=\"simple-table-container\" flex=\"30\"><div class=\"table-title\" style=\"padding-left: 0px\">\nImpostazioni visualizzazione</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nstyle=\"display: flex;padding-left: 20px;padding-right: 50px\" flex><input type=\"number\" maxlength=\"4\" max=\"2200\" \nmin=\"1800\" name=\"anno_corrente\" ng-model=\"vm.contatti.anno_corrente\" placeholder=\"Anno corrente\" \nstyle=\"margin: auto;x\"></md-input-container><md-input-container style=\"display: flex\" flex><md-checkbox \nname=\"note_immobile\" ng-true-value=\"\'1\'\" ng-false-value=\"0\" ng-model=\"vm.contatti.note_immobile\" \nstyle=\"margin: auto;    margin-top: 10px\">Note immobile</md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-bottom: 30px\"><div style=\"display: flex;flex-direction: column\"><h4>Data elaborazione\n</h4><md-datepicker ng-model=\"data_elaborazione\" md-placeholder=\"Seleziona data\" md-open-on-focus></md-datepicker>\n</div></div><div style=\"text-align:right; margin-top:50px\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"anagrafica.$invalid\" ng-click=\"saveVisualSetting()\">Salva</md-button></div></div></div></div></div>");
$templateCache.put("app/main/registrationRequest/registrationRequest.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header custom-color\" layout=\"row\" \nlayout-align=\"space-between\" style=\"height: auto !important; min-height: 0px !important\"><div layout=\"column\" \nlayout-align=\"center start\" style=\"display: inline-block;text-align:center\"><div class=\"title\" style=\"float: left\">\nRichieste di registrazione</div></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"position: relative\"><md-button ng-click=\"deleteAllRequests()\" class=\"md-raised md-warn\" \nstyle=\"position: absolute; right: 18px;top:8px;z-index: 99\">Elimina tutte</md-button><table datatable=\"\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\" \nstyle=\"width: 100% !important\"></table></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">MENU</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation><div layout=\"row\" layout-align=\"center center\" \nstyle=\"bottom: 0; position: absolute;width: 100%;margin-bottom: 25px\"><md-fab-speed-dial md-open=\"isOpen\" \nmd-direction=\"up\" class=\"md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-warn\"><md-icon \nclass=\"icon-menu icon-size custom-icon\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button \naria-label=\"Publish\" ng-click=\"vm.logout()\" class=\"md-raised md-primary md-red-500-bg\">LOGOUT</md-button>\n</md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" style=\"height: 100%\"><div layout=\"row\" layout-align=\"start center\" flex \nstyle=\"height: 100%\"><md-button style=\"height: 100%\" id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div style=\"margin: 2%;height: 70%;width: auto\"><img style=\"max-height: 100%\" ng-src=\"{{getLogo()}}\"></div>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);